<template>
  <div>
    <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
      <!-- 第一板块 -->
      <div class="banner question_banner infoBanBox">
        <img :src="banners.image" alt="" class="infoBan">
        <div class="w1200 infoBanCont">
          <div class="plcs" v-if="saitiStatusCont!=''&&saitiStatusCont!=null">
            <div class="txt tion1">
              <p class="fnt_42">{{ saitiStatusCont.title }}</p>
            </div>
            <div class="tion2">
              <p class="fnt_18" v-for="(val, index) in saitiStatusCont.mark" :key="index">{{ val }}</p>
            </div>
            <div class="tion3">
              <ul class="box_tion3">
                <li v-if="saitiStatusCont.bonus!=''&&saitiStatusCont.bonus!=null">
                  <p class="fnt_28">{{ saitiStatusCont.bonus }}</p>
                  <span class="fnt_16"><img src="@/assets/images/stxq_img1.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_bonus }}</span>
                </li>
                <li>
                  <p class="fnt_28" v-if="saitiStatusCont.teams!=null&&saitiStatusCont.teams!=''">{{ saitiStatusCont.teams > 999 ? '999+' : saitiStatusCont.teams }}</p>
                  <p class="fnt_28" v-else>0</p>
                  <span class="fnt_16"><img src="@/assets/images/stxq_img2.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_teams }}</span>
                </li>
                <!-- <li v-if="saitiStatusCont.type_dictText!=''&&saitiStatusCont.type_dictText!=null">
                  <p class="fnt_28">{{ saitiStatusCont.type_dictText }}</p>
                  <span class="fnt_16"><img src="@/assets/images/stxq_img3.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_type }}</span>
                </li> -->
                <li v-if="saitiStatusCont.categoryTitle!==''&&saitiStatusCont.categoryTitle!==null">
                  <p class="fnt_28">{{ saitiStatusCont.categoryTitle }}</p>
                  <span class="fnt_16"><img src="@/assets/images/stxq_img3.png" alt="">{{ globalDataArray.siteTemplateLanguage.category_select }}</span>
                </li>

                <li v-if="saitiStatusCont.signup!=''&&saitiStatusCont.signup!=null">
                  <p class="fnt_28">
                    <!-- 已结束 -->
                    <template v-if="saitiStatusCont.signup=='04'">
                      {{ saitiStatusCont.signup_dictText }}
                    </template>
                    <template v-else>
                      <!-- 未开始跟进行中 -->
                      <template v-if="saitiStatusCont.signup=='01' || saitiStatusCont.signup=='02'">
                        {{ saitiStatusCont.signup_dictText }}
                      </template>

                      <!-- 报名中 -->
                      <template v-if="saitiStatusCont.signup=='03' && currentTime < saitiStatusCont.localEndtimeStr">
                        {{ saitiStatusCont.signup_dictText }}
                      </template>

                      <!-- 截止报名 -->
                      <template v-if="saitiStatusCont.signup=='03' && currentTime >= saitiStatusCont.localEndtimeStr">
                        {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                      </template>
                    </template>
                  </p>
                  <span class="fnt_16"><img src="@/assets/images/stxq_img4.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_state }}</span>
                </li>
              </ul>
            </div>
            <div class="tion4" v-if="saitiStatusCont.signup!=''&&saitiStatusCont.signup!=null">
              <template v-if="!saitiStatusCont.hasChild">
                <!-- 已结束 -->
                <template v-if="saitiStatusCont.signup=='04'">
                  <div class="tion4bm ended"><span>{{ saitiStatusCont.signup_dictText }}</span></div>
                </template>
                <template v-else>
                  <!-- 已经报名显示已报名 -->
                  <template v-if="saitiStatusCont.signup === '00'">
                    <div class="tion4bm started"><span>不可报名</span> </div>
                  </template>

                  <template v-if="saitiStatusCont.isSignup == 1">
                    <div class="tion4bm started"><span>{{ globalDataArray.siteTemplateLanguage.competition_signup_yes }}</span> </div>
                  </template>

                  <template v-else-if="saitiStatusCont.isSignup == 2">
                    <!--申请中-->
                    <div class="tion4bm started">
                      <span>
                        {{ globalDataArray.siteTemplateLanguage.competition_signup_ing }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="saitiStatusCont.isSignup === '3'">
                    <!-- 审核 -->
                    <a-button class="tion4bm ove">
                      {{ globalDataArray.siteTemplateLanguage.fail }}
                    </a-button>
                  </template>

                  <template v-else>
                    <template v-if="currentTime < saitiStatusCont.localEndtimeStr">
                      <!-- 未开始跟进行中 -->
                      <template v-if="saitiStatusCont.signup=='01' || saitiStatusCont.signup=='02'">
                        <div class="tion4bm started"><span>{{ saitiStatusCont.signup_dictText }}</span></div>
                      </template>

                      <!-- 已超限额 -->
                      <div class="tion4bm ove" v-else-if="saitiStatusCont.isSignup === '10'">
                        <span>{{ globalDataArray.siteTemplateLanguage.competition_signup_button_limit }}</span>
                      </div>

                      <!-- 报名中 -->
                      <template v-else-if="saitiStatusCont.signup=='03'">
                        <div class="tion4bm">
                          <span @click="toSignFun(saitiStatusCont)">
                            {{ globalDataArray.siteTemplateLanguage.click_signup }}
                          </span>
                        </div>
                      </template>
                    </template>

                    <!-- 截止报名 -->
                    <template v-else>
                      <div class="tion4bm ove"><span>{{ globalDataArray.siteTemplateLanguage.competition_signup_end }}</span> </div>
                    </template>
                  </template>
                </template>
              </template>

              <div class="tion4_txt fnt_16" v-if="(saitiStatusCont.organizersLogo && saitiStatusCont.organizersLogo.length > 0) || (saitiStatusCont.organizers && saitiStatusCont.organizers.length > 0)">
                <div class="gjfTit">{{ globalDataArray.siteTemplateLanguage.competition_co_builder }}:</div>
                <div class="logo">
                  <template v-if="saitiStatusCont.organizersLogo && saitiStatusCont.organizersLogo.length > 0">
                    <span class="tion4span img" v-for="(val, index) in saitiStatusCont.organizersLogo" :key="index"><img :src="val" alt=""></span>
                  </template>
                  <template v-else-if="saitiStatusCont.organizers && saitiStatusCont.organizers.length > 0">
                    <span class="tion4span txt" v-for="(val, index) in saitiStatusCont.organizers" :title="val" :key="index">{{ val }}</span>
                  </template>
                </div>
              </div>
            </div>
            <div class="tion5">
              <p class="tion5_mintop fnt_16" v-if="saitiStatusCont.localStarttime!=''&&saitiStatusCont.localStarttime!=null">
                <img src="@/assets/images/stxq_ks.png" alt="">
                {{ globalDataArray.siteTemplateLanguage.competition_start_signup }}： <span>{{ saitiStatusCont.localStarttime }}<span class="utc8"> UTC+8</span></span>
              </p>
              <p class="tion5_mintop fnt_16" v-if="saitiStatusCont.localEndtime!=''&&saitiStatusCont.localEndtime!=null">
                <img src="@/assets/images/stxq_js.png" alt="">
                {{ globalDataArray.siteTemplateLanguage.competition_end_signup }}：<span>{{ saitiStatusCont.localEndtime }}<span class="utc8"> UTC+8</span></span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二板块 -->
      <div class="question" v-if="competition.progress!=''&&competition.progress!=null">
        <div class="competition w1200">
          <div class="process" v-for="(item,index) in competition.progress" :class="item.progressStatus == 0 ? 'on' : item.progressStatus == 1 ? 'active' : ''" :key="index">
            <p class="txtp">{{ item.title }}</p>
            <p class="time">{{ item.startDate }}</p>
          </div>
        </div>
      </div>

      <!-- 第三板块 -->
      <div class="contenta">
        <div class="w1200">
          <div class="content_mine" v-if="combinedData.length">
            <div class="content_left flex flex-col gap-y-24">
              <div class="content_box">
                <h3 class="text-24 leading-30 mx-24 pb-18 pt-24 border-b-1 border-b-solid border-b-[rgba(0,0,0,0.1)]">
                  {{ globalDataArray.siteTemplateLanguage.competition_box_left_top }}
                </h3>
                <ul>
                  <!-- 修改这里：循环combinedData -->
                  <li
                    v-for="(item, index) in combinedData" :key="getItemKey(item, index)"
                    class="fnt_20"
                    :class="index === activeIndex ? 'actire' : ''"
                  >
                    <a href="javascript:;" @click="changeEvent(item, index)">{{ getItemTitle(item) }}</a>
                  </li>
                </ul>
              </div>

              <div class="content_left_bottom">
                <!-- 为了实现特殊布局，所以要写两次 Recommendation 组件 -->
                <Recommendation :id="$route.query.id" />
              </div>
            </div>

            <div class="content_right_sub">
              <div class="content_right">
                <!-- 修改这里：显示对应内容 -->
                <div class="content-wrapper">
                  <div
                    class="content_st"
                    v-for="(item, index) in combinedData"
                    v-show="activeIndex === index"
                    :key="'content-' + getItemKey(item, index)"
                  >
                    <h3 class="fnt_20">{{ getItemTitle(item) }}</h3>
                    <div class="txt ck-content markdown-content" v-html="getItemContent(item)"></div>
                    <div v-if="item.titleCanEdit === 0">
                      <div class="git-url-display">
                        <label class="git-url-label">{{ globalDataArray.siteTemplateLanguage.warehouse_address }}</label>
                        <a-input
                          read-only
                          :value="gitUrl"
                          class="git-input"
                          @keydown="handleKeyDown"
                          @click="openUrl(gitUrl)"
                        >
                          <template #suffix>
                            <a-icon type="link" @click="openUrl(gitUrl)" />
                          </template>
                        </a-input>
                        <a-button
                          @click="handleSubmitWork(item)"
                          v-show="!gitUrl"
                          type="primary"
                          :disabled="isSubmitting"
                        >
                          {{ isSubmitting ? globalDataArray.siteTemplateLanguage.submit_ing : globalDataArray.siteTemplateLanguage.upload_work }}
                        </a-button>
                      </div>
                    </div>
                    <!-- 新增作品信息处理部分 -->
                  </div>
                </div>
              </div>
              <!-- 订阅 -->
              <div class="subscribe-content-box">
                <div class="subscribe-content-box-div">
                  <span class="subscribe-title">{{ getSubscriptionTitle() }}</span>
                  <!--<span class="subscribe-desc">{{ globalDataArray.siteTemplateLanguage.subscription_user_content }}</span>-->
                  <div style="margin-top:20px;">
                    <a-form-model layout="inline" ref="ruleContentForm" :model="ruleContentForm" @submit="submitForm" @submit.native.prevent :rules="contentRules">
                      <a-form-model-item prop="name" style="margin: 10px 10px;">
                        <a-input size="large" v-model="ruleContentForm.name" :placeholder="globalDataArray.siteTemplateLanguage.name_text" class="f-in" />
                      </a-form-model-item>
                      <a-form-model-item prop="email" style="margin: 10px 10px;">
                        <a-input size="large" v-model="ruleContentForm.email" :placeholder="globalDataArray.siteTemplateLanguage.site_email" class="f-in" />
                      </a-form-model-item>
                      <a-form-model-item style="margin: 10px 10px;">
                        <a-button type="primary" html-type="submit" style="width: 175px; height: 40px; line-height: 40px; font-size: 18px;">{{ globalDataArray.siteTemplateLanguage.subscription_user_btn }}</a-button>
                      </a-form-model-item>
                    </a-form-model>
                  </div>
                </div>
              </div>
            </div>

            <div class="content_left_bottom">
              <!-- 为了实现特殊布局，所以要写两次 Recommendation 组件 -->
              <Recommendation :id="$route.query.id" />
            </div>
          </div>
          <div style="text-align:center;" v-else>
            {{ globalDataArray.siteTemplateLanguage.system_data_empty_tips }}
          </div>
        </div>
      </div>
    </div>
    <div class="gotopBtn" @click="goTopFun"></div>

    <!-- 桌面端右侧导航 -->
    <div class="sectionNavBtn" @click="sectionNavFun" v-if="isClient && showNav">
      <div class="arrowLeft"></div>
      <div class="arrowRight" style="display: none;"></div>
      <span :class="getCurrentLanguage() === 'zh_CN' || getCurrentLanguage() === 'zh' ? 'rotate-text-zh' : 'rotate-text'">{{ globalDataArray.siteTemplateLanguage.chapter_navigation }}</span>
    </div>

    <!-- 997px及以下的章节导航按钮 -->
    <div class="mobile-section-nav-btn" @click="sectionNavFun" v-if="isClient && windowWidth <= 1700 && currentArticle && headings.length">
      <div class="nav-arrow" :class="{ 'nav-arrow-open': navOpen }">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 6L1 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span class="nav-text" :class="{ 'english': getCurrentLanguage() !== 'zh_CN' && getCurrentLanguage() !== 'zh' }">{{ globalDataArray.siteTemplateLanguage.chapter_navigation }}</span>
    </div>
    <aside class="section-nav" v-if="isClient && currentArticle && headings.length">
      <div class="nav-wrapper">
        <div class="nav-list">
          <div
            v-for="heading in headings"
            :key="heading.id"
            class="nav-item"
            :class="{ 'nav-item-active': activeHeading === heading.id }"
            @click="handleNavClick(heading)"
          >
            {{ heading.title }}
          </div>
        </div>
      </div>
    </aside>

    <!-- 选择报名方式弹窗 -->
    <signway v-if="signway" :signway.sync="signway" :cur-info-array.sync="curInfoArray" @itemclick="signtypeFun" />

    <!-- 报名弹窗 -->
    <FormsignNew v-if="formsign" :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" @itemclick="formsignFun" :title-name="globalDataArray.siteTemplateLanguage.to_sign_up" :sub-button="globalDataArray.siteTemplateLanguage.right_away_sign" />

    <!-- 加入团队列表 -->
    <formapply v-if="formapply" :formapply.sync="formapply" :cur-info-array.sync="curInfoArray" @itemclick="formapplyFun" />

    <!-- 加入团队信息填写弹窗 -->
    <formmsg-edit-new
      v-if="formmsg"
      :formsign.sync="formmsg" :cur-info-array.sync="curInfoArray" :team-array.sync="teamArray" @itemclick="formmsgFun" sub-button="提交"
      :title-name="globalDataArray.siteTemplateLanguage.apply_join" :place-write="globalDataArray.siteTemplateLanguage.please_write_info"
    />
    <!-- 参赛用户服务协议 -->
    <formxieyi v-if="formxieyi" :formxieyi.sync="formxieyi" :cur-info-array.sync="curInfoArray" :agreement-content="agreementContent" @itemclick="formxieyiFun" />

    <!-- 参数须知 -->
    <form-entry v-if="formEntry" :form-entry.sync="formEntry" :cur-info-array.sync="curInfoArray" :notice-content="noticeContent" @itemclick="formEntryFun" />

    <!-- 官方群二维码弹框-->
    <q-r-code-new v-if="qrCode" :qr-code.sync="qrCode" :cur-info-array.sync="curInfoArray" />
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { stringToDateTime } from '@/utils/util'
import {
  addBrowserAndBookmark
  , getCompetitionInfo
  , addSource
  , getSignupTemplate
  , fetchWorkInfo, submitWork, queryByParentId, addBrowser, UpdateCompetitionTemplateAssociation, historyQueryById
} from '@/api/saiti'
import { addSubscription, getAdList } from '@/api/api'
import { message } from 'ant-design-vue'
import Recommendation from './components/Recommendation.vue'
import { marked } from 'marked'
import FormEntry from '@/components/global/formEntry/index.vue'
import FormmsgEditNew from '@/components/global/formmsg/FormmsgNew.vue'
import FormsignNew from '@/components/global/formsign/FormsignNew.vue'
import QRCodeNew from '@/components/global/qrcodenew/index.vue'
import { createAtomGitRepo } from '@/api/person/person'

// 配置 marked 解析器 - 允许HTML和样式
marked.setOptions({
  breaks: true,
  gfm: true,
  sanitize: false, // 允许HTML标签
  async: false,
  xhtml: false // 使用HTML5风格
})

export default {
  name: 'Sitiinfo',
  components: {
    QRCodeNew,
    FormsignNew,
    FormmsgEditNew,
    FormEntry,
    Recommendation
  },
  asyncData({ store, route }) {
    let id = route.query.id
    if (!id) {
      id = route.params.id
    }

    // 先获取比赛详情
    return store.dispatch('getSaitiInfo', { id: id }).then(async (sitiInfo) => {
      // 获取比赛详情后，再获取articles数据和完整状态信息
      if (sitiInfo && sitiInfo.templateId) {
        try {
          // 导入所需的API方法
          const { getCompetitionInfo, queryByParentId } = await import('@/api/saiti')

          // 获取比赛状态信息
          const param = 'id=' + id
          const competitionRes = await getCompetitionInfo(param)

          if (competitionRes.success) {
            const saitiStatusCont = competitionRes.result

            // 在服务端进行与客户端相同的数据处理，确保渲染一致性
            // 导入时间处理函数
            const { stringToDateTime } = await import('@/utils/util')

            // 处理时间字段
            if (saitiStatusCont.endUtcTime) {
              const endUtcTime = saitiStatusCont.endUtcTime
              const localEndtimeStr = new Date(endUtcTime).getTime()
              saitiStatusCont['localEndtime'] = stringToDateTime(localEndtimeStr)
              saitiStatusCont['localEndtimeStr'] = localEndtimeStr
            }

            if (saitiStatusCont.startUtcTime) {
              const startUtcTime = saitiStatusCont.startUtcTime
              const localStarttimeStr = new Date(startUtcTime).getTime()
              saitiStatusCont['localStarttime'] = stringToDateTime(localStarttimeStr)
            }

            // 处理标签字段 - 确保与客户端处理逻辑一致
            if (saitiStatusCont.mark) {
              saitiStatusCont.mark = saitiStatusCont.mark.split(/[,，]/).filter(item => item.trim())
            }

            // 处理共建方Logo字段
            if (saitiStatusCont.organizersLogo) {
              const organizersLogo = saitiStatusCont.organizersLogo
              saitiStatusCont.organizersLogo = organizersLogo.split(',').filter(item => item.trim())
            }

            // 处理共建方字段
            if (saitiStatusCont.organizers) {
              const organizers = saitiStatusCont.organizers
              saitiStatusCont.organizers = organizers.split(',').filter(item => item.trim())
            }

            // 移除Vuex articles获取，改为在组件mounted时获取，避免不同比赛数据相互干扰

            // 预设置弹窗状态数据，确保服务端和客户端一致
            const modalStates = {
              signway: false,
              formsign: false,
              formapply: false,
              formmsg: false,
              formxieyi: false,
              formEntry: false,
              qrCode: false,
              agreementContent: '',
              noticeContent: '',
              hasAgreementUpdate: saitiStatusCont.hasAgreementUpdate || 0,
              hasNoticeUpdate: saitiStatusCont.hasNoticeUpdate || 0
            }

            // 如果需要显示协议或须知弹窗，预加载内容
            if (saitiStatusCont.hasAgreementUpdate === 1 || saitiStatusCont.hasNoticeUpdate === 1) {
              try {
                // 获取当前语言，优先从store获取
                const language = store.state.globalDataArray?.siteInfo?.language || 'zh_CN'
                const paTemp = 'language=' + language + '&templateId=' + saitiStatusCont.templateId
                const templateRes = await queryByParentId(paTemp)

                if (templateRes.success) {
                  // 使用HTML实体解码函数
                  const decodeHtmlEntities = (content) => {
                    if (!content || typeof content !== 'string') {
                      return content
                    }

                    let decoded = content

                    try {
                      // 解码Unicode转义序列
                      decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
                        return String.fromCharCode(parseInt(code, 16))
                      })

                      // 解码其他转义序列
                      decoded = decoded.replace(/\\n/g, '\n')
                      decoded = decoded.replace(/\\t/g, '\t')
                      decoded = decoded.replace(/\\"/g, '"')
                      decoded = decoded.replace(/\\\\/g, '\\')

                      // 解码HTML实体
                      const htmlEntities = {
                        '&amp;': '&',
                        '&lt;': '<',
                        '&gt;': '>',
                        '&quot;': '"',
                        '&#39;': "'",
                        '&nbsp;': ' '
                      }

                      Object.keys(htmlEntities).forEach(entity => {
                        decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
                      })
                    } catch (error) {
                      console.error('HTML解码错误:', error)
                    }

                    return decoded
                  }

                  modalStates.agreementContent = decodeHtmlEntities(templateRes.result.agreementContent || '')
                  modalStates.noticeContent = decodeHtmlEntities(templateRes.result.noticeContent || '')

                  // 在服务端预设置弹窗显示状态，确保SSR水合一致性
                  // 服务端和客户端必须渲染相同的DOM结构
                  if (saitiStatusCont.hasAgreementUpdate === 1) {
                    modalStates.formxieyi = true
                  }
                  if (saitiStatusCont.hasNoticeUpdate === 1 && saitiStatusCont.hasAgreementUpdate !== 1) {
                    modalStates.formEntry = true
                  }
                }
              } catch (error) {
                console.error('预加载弹窗内容失败:', error)
              }
            }

            // 将弹窗状态存储到store中，供组件使用
            store.commit('setModalStates', modalStates)

            // 设置服务端时间，确保服务端客户端时间比较一致
            store.commit('setCurrentTime', new Date().getTime())

            // 将竞赛状态信息也存储到store中，确保模板条件渲染一致
            store.commit('setSaitiStatusCont', saitiStatusCont)
          }
        } catch (error) {
          console.error('asyncData中获取完整状态失败:', error)
          // 即使失败，也要确保store中有基础数据
          store.commit('setModalStates', {
            signway: false,
            formsign: false,
            formapply: false,
            formmsg: false,
            formxieyi: false,
            formEntry: false,
            qrCode: false,
            agreementContent: '',
            noticeContent: '',
            hasAgreementUpdate: 0,
            hasNoticeUpdate: 0
          })
          store.commit('setCurrentTime', new Date().getTime())
          store.commit('setSaitiStatusCont', {
            hasChild: false,
            signup: '',
            isSignup: 0,
            hasAgreementUpdate: 0,
            hasNoticeUpdate: 0,
            mark: [],
            organizersLogo: [],
            organizers: [],
            localEndtime: '',
            localStarttime: '',
            localEndtimeStr: 0
          })
        }
      }

      return sitiInfo
    }).catch(error => {
      console.error('asyncData中获取数据失败:', error)
      // 确保有基础数据结构
      store.commit('setModalStates', {
        signway: false,
        formsign: false,
        formapply: false,
        formmsg: false,
        formxieyi: false,
        formEntry: false,
        qrCode: false,
        agreementContent: '',
        noticeContent: '',
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0
      })
      store.commit('setCurrentTime', new Date().getTime())
      store.commit('setSaitiStatusCont', {
        hasChild: false,
        signup: '',
        isSignup: 0,
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0,
        mark: [],
        organizersLogo: [],
        organizers: [],
        localEndtime: '',
        localStarttime: '',
        localEndtimeStr: 0
      })
      return {}
    })
  },
  computed: {
    // contentInfo() {
    //   // this.$store.state.sitiInfo.content
    //   // return this.$store.state.sitiInfo
    // }
    // dabing
    // 规范化数据结构（处理数组格式）[6](@ref)
    processedInfo() {
      return (this.$store.state.sitiInfo?.info || []).map(item => ({
        id: item.id || this.generateUUID(),
        title: item.title || '未命名',
        content: item.content || ''
      }))
    },
    // 合并三个数据源
    combinedData() {
      try {
        // 只使用本地articles数据，避免不同比赛数据相互干扰
        const articlesData = this.articles || []

        const competitionInfo = this.competition?.info || []

        // 确保数据是数组
        if (!Array.isArray(competitionInfo) || !Array.isArray(articlesData)) {
          return []
        }

        // 不在这里进行登录状态过滤，确保服务端和客户端渲染一致
        const competitionItems = competitionInfo
          .filter(item => {
            // 只进行基础的数据有效性检查
            return item && typeof item === 'object'
          })
          .map((item, index) => ({
            type: 'competition',
            id: item.id || `comp-${index}`, // 使用索引确保一致性
            title: item.title || '未命名',
            ...item
          }))

        const articleItems = articlesData
          .filter(item => item && typeof item === 'object')
          .map((item, index) => ({
            type: 'article',
            id: item.id || `article-${index}`,
            title: item.title || '未命名',
            content: item.content || '',
            ...item
          }))

        const result = [...competitionItems, ...articleItems]
        return result
      } catch (error) {
        console.error('combinedData计算出错:', error)
        return []
      }
    },

    // 添加弹窗状态计算属性，从store获取
    modalStates() {
      return this.$store.state.modalStates || {
        signway: false,
        formsign: false,
        formapply: false,
        formmsg: false,
        formxieyi: false,
        formEntry: false,
        qrCode: false,
        agreementContent: '',
        noticeContent: '',
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0
      }
    },

    // 为.sync绑定创建computed属性
    signway: {
      get() { return this.modalStates.signway },
      set(value) { this.$store.commit('updateModalState', { key: 'signway', value }) }
    },
    formsign: {
      get() { return this.modalStates.formsign },
      set(value) { this.$store.commit('updateModalState', { key: 'formsign', value }) }
    },
    formapply: {
      get() { return this.modalStates.formapply },
      set(value) { this.$store.commit('updateModalState', { key: 'formapply', value }) }
    },
    formmsg: {
      get() { return this.modalStates.formmsg },
      set(value) { this.$store.commit('updateModalState', { key: 'formmsg', value }) }
    },
    formxieyi: {
      get() { return this.modalStates.formxieyi },
      set(value) { this.$store.commit('updateModalState', { key: 'formxieyi', value }) }
    },
    formEntry: {
      get() { return this.modalStates.formEntry },
      set(value) { this.$store.commit('updateModalState', { key: 'formEntry', value }) }
    },
    qrCode: {
      get() { return this.modalStates.qrCode },
      set(value) { this.$store.commit('updateModalState', { key: 'qrCode', value }) }
    },
    agreementContent: {
      get() { return this.modalStates.agreementContent },
      set(value) { this.$store.commit('updateModalState', { key: 'agreementContent', value }) }
    },
    noticeContent: {
      get() { return this.modalStates.noticeContent },
      set(value) { this.$store.commit('updateModalState', { key: 'noticeContent', value }) }
    },

    // 从store获取当前时间，确保服务端客户端一致
    currentTime() {
      return this.$store.state.currentTime
    },

    // 从store获取竞赛状态信息，确保服务端客户端一致
    saitiStatusCont() {
      return this.$store.state.saitiStatusCont || {
        hasChild: false,
        signup: '',
        isSignup: 0,
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0,
        mark: [],
        organizersLogo: [],
        organizers: [],
        localEndtime: '',
        localStarttime: '',
        localEndtimeStr: 0
      }
    }

  },
  data() {
    return {
      activeIndex: 0,
      id: undefined,
      inviteId: undefined,
      queryId: '',
      banners: [],
      competition: {
        info: []
      },
      // currentTime 已移至 store 中管理
      event: 0,
      info: {},
      articles: [], // 文章数据
      currentArticle: null, // 当前文章
      showNav: false, // SSR兼容：统一初始为false，避免水合不匹配
      isMobile: false, // SSR兼容：统一初始为false，避免水合不匹配
      isClient: false, // 客户端标识
      tocExpanded: false, // 本页总览默认展开

      headings: [], // 添加headings数组存储标题导航
      activeHeading: '', // 当前激活的标题ID
      isNavigating: false, // 是否正在导航中
      navigationTimer: null, // 导航定时器
      lastClickTime: 0, // 最后点击时间
      clickDebounceDelay: 300, // 点击防抖延迟(ms)
      work: {
        title: '作品信息',
        content: '<p>内容加载中...</p>',
        codeAdress: ''
      }, // 作品数据
      parsedContent: new Map(), // 使用Map存储解析结果

      curInfoArray: {
        categoryId: '', // 当前赛题分类id
        competitionId: '', // 当前赛题id
        templateId: '', // 报名模板
        currentLanguge: '',
        teamsUsers: '',
        teams: '',
        parentId: '',
        zoneId: ''
      },
      teamArray: {},
      // 新增数据状态
      gitUrl: null,
      teamNo: null,
      workLoading: false,
      workError: null,
      isSubmitting: false,
      hasCheckedWork: false, // 防止重复检查
      navOpen: false, // 导航是否展开状态
      resizeTimeout: null, // 窗口大小变化防抖定时器

      ruleContentForm: {
        name: undefined,
        email: undefined
      },
      contentRules: {
        name: [
          { required: true, message: this.globalDataArray.siteTemplateLanguage.subscription_user_name, trigger: 'submit' },
          { min: 1, max: 50, message: this.globalDataArray.siteTemplateLanguage.subscription_user_name_length, trigger: 'submit' }
        ],
        email: [
          { required: true, message: this.globalDataArray.siteTemplateLanguage.subscription_user_email_null, trigger: 'submit' },
          { type: 'email', message: this.globalDataArray.siteTemplateLanguage.subscription_user_email, trigger: 'submit' }
        ]
      },
      windowWidth: 1920 // 新增，记录当前窗口宽度
    }
  },
  watch: {
    // 监听当前激活的标签页
    activeIndex: {
      handler(newVal) {
        const currentItem = this.combinedData[newVal]
        this.currentArticle = currentItem

        if (this.currentArticle) {
          // 等待内容渲染完成后再解析标题
          this.$nextTick(() => {
            // 再次等待，确保v-html渲染完成
            setTimeout(() => {
              this.parseHeadings() // 基于实际DOM元素解析导航
            }, 100)
          })
        }

        if (currentItem && currentItem.title === '作品介绍' && !this.hasCheckedWork) {
          const params = 'competitionId=' + this.$route.query.id
          fetchWorkInfo().then(res => {
            if (res.success && res.result?.records[0]?.gitUrl) {
              this.gitUrl = res.result.records[0].gitUrl
            }
            if (res.success && res.result?.records[0]?.id) {
              this.teamNo = res.result.records[0].id
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    // 深度监听数据变化自动更新[3,7](@ref)
    'processedInfo': {
      handler() {
        this.initContentParsing()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    let id = this.$route.query.id
    if (!id) {
      id = this.$route.params.id
    }
    this.id = id
    const inviteId = this.$route.params.inviteId
    this.inviteId = inviteId
  },
  mounted() {
    // 在客户端更新时间，如果服务端没有设置时间的话
    if (this.$store.state.currentTime === 0) {
      this.$store.commit('setCurrentTime', new Date().getTime())
    }

    this.init()

    if (typeof document === 'object') {
      document.documentElement.scrollTop = 0
    }

    let referrer = document.referrer
    if (!referrer) {
      referrer = this.$route.query.source
    }
    if (referrer) {
      this.addSource(referrer)
    }

    const currentItem = this.combinedData[this.activeIndex]
    // console.log('======> currentItem', currentItem)
    this.currentArticle = currentItem
    if (this.currentArticle) {
      // console.log('======> this.currentArticle', this.currentArticle)
      this.parseHeadings() // 基于实际DOM元素解析导航
    }

    // 设置客户端状态，确保SSR水合一致性
    this.isClient = true
    this.$nextTick(() => {
      // 设置正确的响应式状态，修复断点逻辑与CSS媒体查询保持一致
      this.showNav = window.innerWidth > 997
      this.isMobile = window.innerWidth <= 768
      this.windowWidth = window.innerWidth // 新增
    })

    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)

    // 添加滚动监听
    window.addEventListener('scroll', this.handleScrollThrottle)

    // 添加点击外部区域关闭导航的监听
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy() {
    if (this.$isServer) return
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScrollThrottle)
    document.removeEventListener('click', this.handleClickOutside)

    // 清理导航定时器
    if (this.navigationTimer) {
      clearTimeout(this.navigationTimer)
      this.navigationTimer = null
    }

    // 清理窗口大小变化防抖定时器
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = null
    }

    // 清理滚动动画帧
    if (this.scrollFrame) {
      cancelAnimationFrame(this.scrollFrame)
    }
  },

  methods: {
    // 获取 URL 参数的工具函数
    getQueryParam(paramName) {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get(paramName)
    },
    saitiAccessInfo() {
      return Cookies.get('saiti_access_info')
    },
    // 生成唯一key
    getItemKey(item, index) {
      return item.id ? `${item.type}-${item.id}` : `${item.type}-${index}`
    },
    // 获取标题
    getItemTitle(item) {
      return item.title || 'Untitled'
    },
    // 获取内容（根据不同类型处理）- 修复水合问题
    getItemContent(item) {
      try {
        let content = ''
        if (item.type === 'competition') {
          // 修复水合问题：如果缓存为空，立即解析内容而不是显示Loading
          content = this.parsedContent.get(item.id)
          if (!content) {
            // 缓存为空时，直接解析内容确保SSR一致性
            content = this.parseMarkdown(item.content || '')
            // 解析完成后更新缓存
            if (content) {
              this.parsedContent.set(item.id, content)
            }
          }
        } else {
          content = this.parseMarkdown(item.content)
        }

        // 清理可能导致DOM错误的内容但保留HTML结构
        const cleanedContent = this.cleanDOMBreakingContent(content)

        // 新增：额外的DOM安全验证，特别针对CDN环境和响应式渲染问题
        if (!this.validateDOMStructure(cleanedContent)) {
          console.warn('DOM结构验证失败，使用安全降级版本')
          return this.createSafeFallbackContent(item, content)
        }

        return cleanedContent
      } catch (error) {
        console.error('getItemContent error:', error)
        return this.createSafeFallbackContent(item, null, error)
      }
    },

    // 加强版：清理可能导致DOM错误的字符但保留HTML结构，特别针对CDN和响应式环境
    cleanDOMBreakingContent(content) {
      if (!content || typeof content !== 'string') {
        return '<p>内容为空</p>'
      }

      try {
        let cleaned = content

        // 1. 移除可能导致appendChild错误的零宽字符和控制字符，但保留有效的空白字符
        cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, '') // 零宽字符
        // 危险的控制字符，但保留tab(\u0009)、换行(\u000A)、回车(\u000D)
        cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '') // 危险的控制字符

        // 2. 清理BOM和替换字符
        cleaned = cleaned.replace(/^\uFEFF/, '') // 移除BOM
        cleaned = cleaned.replace(/\uFFFD/g, '') // 移除替换字符

        // 3. 新增：修复可能导致appendChild错误的特殊HTML结构
        // 移除可能导致DOM解析问题的注释节点
        cleaned = cleaned.replace(/<!--[\s\S]*?-->/g, '')

        // 修复嵌套不当的标签（可能导致appendChild错误）
        cleaned = this.fixNestedTags(cleaned)

        // 修复可能的孤立尖括号（但保留正确的HTML标签）
        cleaned = this.fixBrokenAngularBrackets(cleaned)

        // 4. 清理可能导致DOM问题的空属性和畸形属性
        cleaned = cleaned.replace(/\s+(\w+)=""\s*/g, ' ') // 移除空属性
        cleaned = cleaned.replace(/\s+(\w+)="\s*"\s*/g, ' ') // 移除只有空白的属性
        // 修复畸形的属性（没有引号或引号不匹配）
        cleaned = this.fixMalformedAttributes(cleaned)

        // 5. 新增：CDN环境下的特殊处理
        if (this.isCDNEnvironment()) {
          cleaned = this.applyCDNSpecificFixes(cleaned)
        }

        // 6. 新增：响应式环境下的DOM结构统一化
        cleaned = this.normalizeResponsiveContent(cleaned)

        // 7. 最终安全检查
        if (!cleaned.trim()) {
          return '<p>内容为空</p>'
        }

        // 验证清理后的内容是否仍然有效
        if (!this.basicContentValidation(cleaned)) {
          console.warn('内容清理后仍不安全，使用纯文本版本')
          return `<p>${this.escapeHtml(content.replace(/<[^>]*>/g, '').trim().substring(0, 200))}...</p>`
        }

        return cleaned
      } catch (error) {
        console.error('cleanDOMBreakingContent error:', error)
        return `<p style="color: #999;">内容处理出错: ${this.escapeHtml(error.message)}</p>`
      }
    },

    // 新增：修复嵌套不当的HTML标签
    fixNestedTags(content) {
      try {
        // 修复常见的嵌套问题，如p标签内嵌套div等块级元素
        let fixed = content

        // 移除p标签内的块级元素嵌套
        fixed = fixed.replace(/<p([^>]*)>([\s\S]*?)<div([^>]*)>([\s\S]*?)<\/div>([\s\S]*?)<\/p>/gi,
          '<p$1>$2</p><div$3>$4</div><p>$5</p>')

        // 修复self-closing标签的问题
        fixed = fixed.replace(/<(br|hr|img|input|meta|link)\s+([^>]*?)\s*>/gi, '<$1 $2 />')

        // 修复未闭合的标签（基础修复）
        const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'source', 'track', 'wbr']
        voidElements.forEach(tag => {
          const regex = new RegExp(`<${tag}([^>]*?)(?<!/)>`, 'gi')
          fixed = fixed.replace(regex, `<${tag}$1 />`)
        })

        return fixed
      } catch (error) {
        console.warn('修复嵌套标签失败:', error)
        return content
      }
    },

    // 新增：修复破损的尖括号
    fixBrokenAngularBrackets(content) {
      try {
        let fixed = content

        // 更安全的方式处理孤立的尖括号，避免破坏正确的HTML标签
        // 使用负向后瞻和前瞻来识别真正孤立的尖括号
        fixed = fixed.replace(/(?<!<[^>]*)<(?![a-zA-Z\/!?\s])/g, '&lt;')
        fixed = fixed.replace(/(?<![a-zA-Z0-9\s"'=\/])>(?!\s*[<\w])/g, '&gt;')

        // 修复属性中的问题尖括号
        fixed = fixed.replace(/(\w+="[^"]*)<([^">]*")/g, '$1&lt;$2')
        fixed = fixed.replace(/(\w+="[^"]*)>([^">]*")/g, '$1&gt;$2')

        return fixed
      } catch (error) {
        console.warn('修复尖括号失败:', error)
        return content
      }
    },

    // 新增：修复畸形的HTML属性
    fixMalformedAttributes(content) {
      try {
        let fixed = content

        // 修复没有引号的属性值（但只处理安全的情况）
        fixed = fixed.replace(/(\w+)=([a-zA-Z0-9\-_]+)(?=\s|>)/g, '$1="$2"')

        // 修复单引号属性
        fixed = fixed.replace(/(\w+)='([^']*)'/g, '$1="$2"')

        // 移除无效的属性（如属性名包含特殊字符）
        fixed = fixed.replace(/[^\w\-]+="[^"]*"/g, '')

        return fixed
      } catch (error) {
        console.warn('修复属性失败:', error)
        return content
      }
    },

    // 新增：CDN环境下的特殊修复
    applyCDNSpecificFixes(content) {
      try {
        let fixed = content

        // CDN可能导致的编码问题修复
        // 修复双重编码问题
        fixed = fixed.replace(/&amp;amp;/g, '&amp;')
        fixed = fixed.replace(/&lt;lt;/g, '&lt;')
        fixed = fixed.replace(/&gt;gt;/g, '&gt;')

        // 修复CDN可能引入的额外空白字符
        fixed = fixed.replace(/\u00A0+/g, ' ') // 替换连续的非断空格
        fixed = fixed.replace(/[\u2000-\u200A\u202F\u205F]/g, ' ') // 替换各种空格字符

        // 修复CDN缓存可能导致的版本混合问题
        // 移除可能的版本标识注释
        fixed = fixed.replace(/<!--\s*version[^>]*-->/gi, '')
        fixed = fixed.replace(/<!--\s*cdn[^>]*-->/gi, '')

        return fixed
      } catch (error) {
        console.warn('CDN特殊修复失败:', error)
        return content
      }
    },

    // 新增：响应式内容的DOM结构统一化
    normalizeResponsiveContent(content) {
      try {
        let normalized = content

        // 移除可能导致响应式问题的内联样式（保留基础样式）
        // 只移除可能导致布局冲突的样式
        const problematicStyles = [
          /position\s*:\s*fixed/gi,
          /position\s*:\s*absolute/gi,
          /z-index\s*:\s*\d+/gi,
          /transform\s*:[^;]*/gi
        ]

        problematicStyles.forEach(pattern => {
          normalized = normalized.replace(new RegExp(`style="([^"]*?)${pattern.source}[^"]*"`, 'gi'),
            (match, beforeStyle) => {
              const cleanStyle = beforeStyle.replace(pattern, '').trim()
              return cleanStyle ? `style="${cleanStyle}"` : ''
            })
        })

        // 统一化可能导致响应式问题的类名（如果存在冲突的话）
        // 这里只做基础清理，避免过度处理
        normalized = normalized.replace(/class="[^"]*mobile[^"]*desktop[^"]*"/gi, 'class="responsive-content"')

        return normalized
      } catch (error) {
        console.warn('响应式内容标准化失败:', error)
        return content
      }
    },

    // 新增：验证内容方法，帮助调试
    validateContent(content) {
      if (!content || typeof content !== 'string') {
        return false
      }

      // 服务端环境跳过DOM验证
      if (this.$isServer) {
        return true
      }

      try {
        // 简单的DOM验证：尝试创建临时元素
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = content
        return true
      } catch (error) {
        // console.warn('Content validation failed:', error.message)
        return false
      }
    },

    // 新增：调试空白字符解析的方法
    debugWhitespaceDecoding(content) {
      if (!content || typeof content !== 'string') {
        return 'No content to debug'
      }

      // 显示原始内容中的特殊字符
      const analysis = {
        original: content.substring(0, 200),
        hasTab: content.includes('\t') || content.includes('\\t') || content.includes('&#9;') || content.includes('\\u0009'),
        hasSpace: content.includes(' ') || content.includes('\\u0020') || content.includes('&#32;'),
        hasNbsp: content.includes('\u00A0') || content.includes('&nbsp;') || content.includes('&#160;'),
        hasNewline: content.includes('\n') || content.includes('\\n') || content.includes('&#10;'),
        decoded: this.decodeHtmlEntities(content).substring(0, 200)
      }

      // console.log('空白字符解析调试:', analysis)
      return analysis
    },

    // 新增：DOM结构安全验证，特别针对CDN和响应式环境
    validateDOMStructure(content) {
      if (!content || typeof content !== 'string') {
        return false
      }

      // 服务端环境跳过复杂验证，使用基础验证
      if (this.$isServer) {
        return this.basicContentValidation(content)
      }

      try {
        // 创建临时容器进行DOM验证
        const tempContainer = document.createElement('div')

        // 使用DocumentFragment进行更安全的验证
        const fragment = document.createDocumentFragment()
        const testDiv = document.createElement('div')

        // 先进行基础HTML解析测试
        try {
          testDiv.innerHTML = content
        } catch (parseError) {
          console.warn('HTML解析失败:', parseError)
          return false
        }

        // 验证所有子节点是否可以正常添加
        const children = Array.from(testDiv.childNodes)
        for (let i = 0; i < children.length; i++) {
          const child = children[i]

          // 检查节点类型
          if (child.nodeType === Node.ELEMENT_NODE) {
            // 检查是否是有效的HTML元素
            if (!this.isValidHTMLElement(child)) {
              console.warn('发现无效HTML元素:', child.tagName)
              return false
            }
          } else if (child.nodeType === Node.TEXT_NODE) {
            // 文本节点检查
            if (!this.isValidTextNode(child)) {
              console.warn('发现无效文本节点')
              return false
            }
          } else if (child.nodeType === Node.COMMENT_NODE) {
            // 注释节点通常是安全的
            continue
          } else if (child.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            // DocumentFragment需要递归检查
            continue
          } else {
            // 其他类型的节点可能导致appendChild错误
            console.warn('发现非标准节点类型:', child.nodeType, child)
            return false
          }

          // 尝试实际添加到fragment中进行测试
          try {
            const clonedChild = child.cloneNode(true)
            fragment.appendChild(clonedChild)
          } catch (appendError) {
            console.warn('appendChild测试失败:', appendError)
            return false
          }
        }

        return true
      } catch (error) {
        console.warn('DOM结构验证异常:', error)
        return false
      }
    },

    // 新增：基础内容验证（用于服务端和降级场景）
    basicContentValidation(content) {
      if (!content || typeof content !== 'string') {
        return false
      }

      // 检查内容长度，过长的内容可能有问题
      if (content.length > 1000000) { // 1MB
        console.warn('内容过长，可能存在问题')
        return false
      }

      // 检查是否包含明显的问题字符或模式
      const dangerousPatterns = [
        /<script[^>]*>[\s\S]*?<\/script>/gi, // 脚本标签
        /javascript:/gi, // JavaScript协议
        /on\w+\s*=/gi, // 事件处理器
        /<iframe[^>]*>[\s\S]*?<\/iframe>/gi, // iframe标签
        /<object[^>]*>[\s\S]*?<\/object>/gi, // object标签
        /<embed[^>]*>/gi // embed标签
      ]

      for (const pattern of dangerousPatterns) {
        if (pattern.test(content)) {
          console.warn('发现潜在危险内容模式')
          return false
        }
      }

      // 检查HTML标签是否成对出现（基础检查）
      const openTags = (content.match(/<[^/][^>]*>/g) || []).length
      const closeTags = (content.match(/<\/[^>]*>/g) || []).length
      const selfClosingTags = (content.match(/<[^>]*\/>/g) || []).length

      // 简单的标签平衡检查
      if (Math.abs(openTags - closeTags - selfClosingTags) > 5) {
        console.warn('HTML标签可能不平衡')
        return false
      }

      return true
    },

    // 新增：验证HTML元素是否有效
    isValidHTMLElement(element) {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return false
      }

      const tagName = element.tagName.toLowerCase()

      // 白名单：允许的HTML标签
      const allowedTags = [
        'div', 'span', 'p', 'br', 'hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li', 'dl', 'dt', 'dd', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
        'a', 'img', 'strong', 'b', 'em', 'i', 'u', 's', 'del', 'ins', 'mark',
        'code', 'pre', 'blockquote', 'q', 'cite', 'abbr', 'dfn', 'time',
        'section', 'article', 'header', 'footer', 'nav', 'aside', 'main',
        'figure', 'figcaption', 'details', 'summary', 'dialog',
        'small', 'sub', 'sup', 'kbd', 'samp', 'var'
      ]

      if (!allowedTags.includes(tagName)) {
        console.warn('不允许的HTML标签:', tagName)
        return false
      }

      // 检查属性
      for (let i = 0; i < element.attributes.length; i++) {
        const attr = element.attributes[i]
        if (!this.isValidAttribute(attr.name, attr.value)) {
          return false
        }
      }

      return true
    },

    // 新增：验证HTML属性是否安全
    isValidAttribute(name, value) {
      const attrName = name.toLowerCase()

      // 危险属性黑名单
      const dangerousAttrs = [
        'onclick', 'onload', 'onerror', 'onmouseover', 'onmouseout',
        'onfocus', 'onblur', 'onchange', 'onsubmit', 'onreset',
        'onkeydown', 'onkeyup', 'onkeypress', 'onmousedown', 'onmouseup'
      ]

      if (dangerousAttrs.includes(attrName)) {
        console.warn('发现危险属性:', name)
        return false
      }

      // 检查属性值
      if (value && typeof value === 'string') {
        const lowerValue = value.toLowerCase()
        if (lowerValue.includes('javascript:') || lowerValue.includes('vbscript:') || lowerValue.includes('data:text/html')) {
          console.warn('发现危险属性值:', value)
          return false
        }
      }

      return true
    },

    // 新增：验证文本节点是否安全
    isValidTextNode(textNode) {
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) {
        return false
      }

      const text = textNode.textContent || textNode.nodeValue || ''

      // 检查文本内容长度
      if (text.length > 100000) {
        console.warn('文本节点过长')
        return false
      }

      // 检查文本内容是否包含危险字符
      // 排除一些可能导致DOM解析问题的控制字符
      const dangerousChars = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\uFFFD]/g
      if (dangerousChars.test(text)) {
        console.warn('发现危险文本字符')
        return false
      }

      return true
    },

    // 新增：创建安全的降级内容
    createSafeFallbackContent(item, originalContent = null, error = null) {
      const title = this.getItemTitle(item)
      const safeTitle = this.escapeHtml(title)

      // 根据环境和错误类型提供不同的降级方案
      if (error) {
        console.error('内容处理错误，使用错误降级方案:', error)
        return `
          <div class="content-error-fallback" style="background: #fff2f0; border: 1px solid #ffccc7; border-radius: 6px; padding: 16px; margin: 16px 0;">
            <h4 style="color: #ff4d4f; margin-bottom: 12px;">${safeTitle}</h4>
            <p style="color: #cf1322; margin-bottom: 8px;">内容加载出现问题，请刷新页面重试</p>
            <details style="margin-top: 12px;">
              <summary style="cursor: pointer; color: #666;">技术详情</summary>
              <pre style="background: #f5f5f5; padding: 8px; margin-top: 8px; font-size: 12px; overflow: auto;">${this.escapeHtml(error.message || '未知错误')}</pre>
            </details>
          </div>
        `
      }

      // CDN环境下的特殊处理
      if (this.isCDNEnvironment()) {
        return `
          <div class="content-cdn-fallback" style="background: #f6ffed; border: 1px solid #b7eb8f; border-radius: 6px; padding: 16px; margin: 16px 0;">
            <h4 style="color: #389e0d; margin-bottom: 12px;">${safeTitle}</h4>
            <p style="color: #52c41a; margin-bottom: 8px;">内容正在从CDN加载中...</p>
            <div style="margin-top: 12px;">
              <small style="color: #666;">如果内容长时间未显示，请<a href="javascript:location.reload()" style="color: #1890ff;">刷新页面</a></small>
            </div>
          </div>
        `
      }

      // 标准降级内容
      let fallbackContent = `<div class="content-safe-fallback" style="background: #f5f5f5; border: 1px solid #d9d9d9; border-radius: 6px; padding: 16px; margin: 16px 0;"><h4 style="color: #333; margin-bottom: 12px;">${safeTitle}</h4>`

      if (originalContent && typeof originalContent === 'string') {
        // 尝试提取纯文本内容
        const textContent = originalContent.replace(/<[^>]*>/g, '').trim()
        if (textContent) {
          const safeText = this.escapeHtml(textContent.substring(0, 500))
          fallbackContent += `<p style="color: #666; line-height: 1.6;">${safeText}${textContent.length > 500 ? '...' : ''}</p>`
        }
      }

      fallbackContent += `<p style="margin-top: 12px;"><small style="color: #999;">内容正在以安全模式显示</small></p></div>`

      return fallbackContent
    },

    // 新增：检查是否在CDN环境
    isCDNEnvironment() {
      if (this.$isServer) return false

      try {
        const hostname = window.location.hostname
        const userAgent = navigator.userAgent || ''

        // 检查是否包含CDN相关域名特征
        const cdnPatterns = [
          /\.cdn\./i,
          /\.cloudflare\./i,
          /\.cloudfront\./i,
          /\.fastly\./i,
          /\.jsdelivr\./i,
          /\.unpkg\./i,
          /cache/i,
          /edge/i
        ]

        const hasCDNDomain = cdnPatterns.some(pattern => pattern.test(hostname))

        // 检查请求头或其他CDN标识
        const hasCDNHeaders = document.querySelector('meta[name="cdn"]') !== null

        return hasCDNDomain || hasCDNHeaders
      } catch (error) {
        return false
      }
    },

    // 新增：HTML转义函数
    escapeHtml(text) {
      if (!text || typeof text !== 'string') return ''

      try {
        if (this.$isServer) {
          // 服务端环境使用简单替换
          return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
        } else {
          // 客户端环境使用DOM方法
          const div = document.createElement('div')
          div.textContent = text
          return div.innerHTML
        }
      } catch (error) {
        // 降级到简单替换
        return text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      }
    },
    // 强化的HTML实体和转义序列解码函数
    decodeHtmlEntities(content) {
      if (!content || typeof content !== 'string') {
        return content
      }

      let decoded = content

      try {
        // 直接解码常见的JSON转义序列，包括空白字符
        if (decoded.includes('\\u003C') || decoded.includes('\\u002F') || decoded.includes('\\"') || decoded.includes('\\u0020') || decoded.includes('\\u0009')) {
          // 直接替换常见的JSON编码字符，包括各种空白字符
          const jsonReplacements = {
            '\\u003C': '<',
            '\\u003E': '>',
            '\\u002F': '/',
            '\\u0026': '&',
            '\\u0022': '"',
            '\\u0027': "'",
            '\\u003D': '=',
            '\\u0020': ' ', // 普通空格
            '\\u00A0': '\u00A0', // 不换行空格 (NBSP)
            '\\u000A': '\n', // 换行
            '\\u000D': '\r', // 回车
            '\\u0009': '\t', // 制表符
            '\\u000B': '\v', // 垂直制表符
            '\\u000C': '\f' // 换页符
          }
          Object.keys(jsonReplacements).forEach(encoded => {
            if (decoded.includes(encoded)) {
              decoded = decoded.replace(new RegExp(encoded, 'g'), jsonReplacements[encoded])
            }
          })
        }

        // 安全地解码Unicode转义序列（\uXXXX格式），保留空白字符
        decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 保留有用的空白字符，跳过危险的控制字符
          if (charCode >= 0x0000 && charCode <= 0x001F &&
              charCode !== 0x0009 && // tab
              charCode !== 0x000A && // 换行
              charCode !== 0x000D && // 回车
              charCode !== 0x000B && // 垂直制表符
              charCode !== 0x000C) { // 换页符
            return '' // 跳过其他危险的控制字符
          }
          if (charCode >= 0x200B && charCode <= 0x200D) {
            return '' // 跳过零宽字符
          }
          return String.fromCharCode(charCode)
        })

        // 解码各种类型的转义序列，包括空白字符的不同表示形式
        decoded = decoded.replace(/\\n/g, '\n') // 换行
        decoded = decoded.replace(/\\t/g, '\t') // 制表符
        decoded = decoded.replace(/\\r/g, '\r') // 回车
        decoded = decoded.replace(/\\v/g, '\v') // 垂直制表符
        decoded = decoded.replace(/\\f/g, '\f') // 换页符
        decoded = decoded.replace(/\\ /g, ' ') // 转义的空格
        decoded = decoded.replace(/\\"/g, '"') // 双引号
        decoded = decoded.replace(/\\'/g, "'") // 单引号
        decoded = decoded.replace(/\\\\/g, '\\') // 反斜杠（放在最后处理）

        // 手动解码常见的HTML实体，包括各种空白字符
        const htmlEntities = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#39;': "'",
          '&#x27;': "'",
          '&#x2F;': '/',
          '&#x60;': '`',
          '&#x3D;': '=',
          // 空白字符的HTML实体
          '&nbsp;': '\u00A0', // 不换行空格
          '&ensp;': '\u2002', // En空格 (en space)
          '&emsp;': '\u2003', // Em空格 (em space)
          '&thinsp;': '\u2009', // 细空格 (thin space)
          '&#32;': ' ', // 普通空格
          '&#160;': '\u00A0', // 不换行空格 (NBSP)
          '&#9;': '\t', // 制表符
          '&#09;': '\t', // 制表符（前导零）
          '&#x09;': '\t', // 制表符（十六进制）
          '&#x0009;': '\t', // 制表符（十六进制完整）
          '&#13;': '\r', // 回车
          '&#10;': '\n', // 换行
          '&#x0A;': '\n', // 换行（十六进制）
          '&#x0D;': '\r' // 回车（十六进制）
        }

        Object.keys(htmlEntities).forEach(entity => {
          if (decoded.includes(entity)) {
            decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
          }
        })
      } catch (error) {
        // console.error('decodeHtmlEntities: Error during decoding:', error)
        // 如果解码失败，至少尝试基本的安全Unicode解码，保留空白字符
        decoded = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 解码安全字符，包括重要的空白字符
          if ((charCode >= 0x0020 && charCode < 0x200B) || // 基本安全字符范围
              charCode === 0x0009 || // tab
              charCode === 0x000A || // 换行
              charCode === 0x000D || // 回车
              charCode === 0x00A0) { // 不换行空格
            return String.fromCharCode(charCode)
          }
          return ''
        })
      }

      return decoded
    },

    parseMarkdown(content) {
      try {
        if (!content || typeof content !== 'string') {
          return '<p>内容为空</p>'
        }

        // 先解码HTML实体和Unicode转义序列
        const decodedContent = this.decodeHtmlEntities(content)

        const parsed = marked.parse(decodedContent)
        if (!parsed || parsed.trim() === '') {
          return `<div class="markdown-fallback"><pre>${this.cleanDOMBreakingContent(decodedContent)}</pre></div>`
        }

        // 对解析后的内容进行安全清理，但保留HTML结构
        const cleanedParsed = this.cleanDOMBreakingContent(parsed)

        // console.log('parseMarkdown: 解析成功', { original: content.substring(0, 100), parsed: cleanedParsed.substring(0, 100) })

        return cleanedParsed
      } catch (e) {
        console.error('parseMarkdown: 解析失败:', e)
        return `<div class="markdown-error">
          <p class="error">Markdown解析异常</p>
          <details>
            <summary>查看原始内容</summary>
            <pre>${content}</pre>
          </details>
        </div>`
      }
    },
    // 检测内容类型是否为Markdown
    detectContentType(content) {
      // 添加安全检查
      if (!content || typeof content !== 'string') {
        return false
      }

      // 增强的markdown检测模式
      const markdownPatterns = [
        /^#+ /m, // 标题 (多行模式)
        /^#{1,6}\s+/m, // 标题的另一种写法
        /\[.*?\]\(.*?\)/, // 链接
        /\*\*.*?\*\*/, // 粗体
        /\*.*?\*/, // 斜体
        /`.*?`/, // 行内代码
        /```[\s\S]*?```/, // 代码块
        /^\s*\-\s+/m, // 无序列表
        /^\s*\*\s+/m, // 无序列表
        /^\s*\+\s+/m, // 无序列表
        /^\s*\d+\.\s+/m, // 有序列表
        /^\s*>\s+/m, // 引用
        /^\s*\|\s*.*?\s*\|/m, // 表格
        /^---+$/m, // 分隔线
        /^\s*\n```/m, // 代码块开始
        /~~.*?~~/, // 删除线
        /==.*?==/, // 高亮
        /^\s{4,}/m, // 代码缩进
        /\n\s*\n/, // 多个空行
        /\*\*\*.*/m // 分隔线（三个星号）
      ]

      // 检查是否包含markdown特征
      const hasMarkdownFeatures = markdownPatterns.some(pattern => pattern.test(content))

      // 如果包含HTML标签且没有明显markdown特征，优先判断为HTML
      if (/<[^>]*>/g.test(content) && !hasMarkdownFeatures) {
        return false // 返回false表示不是markdown，应该按HTML处理
      }

      // 如果没有检测到markdown特征，但内容包含换行符且不是HTML，也可能是markdown纯文本
      if (!hasMarkdownFeatures && content.includes('\n') && !/<[^>]*>/g.test(content)) {
        // 检查是否是纯文本格式的markdown（简单的换行格式）
        const lines = content.split('\n')
        const hasStructure = lines.some(line => {
          const trimmed = line.trim()
          return trimmed.startsWith('#') ||
              trimmed.startsWith('-') ||
              trimmed.startsWith('*') ||
              trimmed.startsWith('+') ||
              /^\d+\./.test(trimmed)
        })
        return hasStructure
      }

      return hasMarkdownFeatures
    },

    initContentParsing() {
      const cache = new Map()
      this.processedInfo.forEach(item => {
        const originalContent = item.content || ''

        // 先解码HTML实体
        const decodedContent = this.decodeHtmlEntities(originalContent)
        const isMarkdown = this.detectContentType(decodedContent)

        if (isMarkdown) {
          cache.set(item.id, this.parseMarkdown(originalContent)) // parseMarkdown内部会解码和清理
        } else {
          if (decodedContent.includes('<') && decodedContent.includes('>')) {
            cache.set(item.id, this.cleanDOMBreakingContent(decodedContent)) // 使用解码和清理后的内容
          } else {
            // 对于纯文本，至少保留换行符
            const textWithBreaks = decodedContent.replace(/\n/g, '<br>')
            cache.set(item.id, this.cleanDOMBreakingContent(textWithBreaks))
          }
        }
      })
      this.parsedContent = cache
    },

    // 处理窗口大小变化 - 改进版，防止DOM操作错误
    handleResize() {
      if (this.$isServer || !this.isClient) return
      this.windowWidth = window.innerWidth // 新增
      try {
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout)
        }
        this.resizeTimeout = setTimeout(() => {
          const currentWidth = window.innerWidth
          this.windowWidth = currentWidth // 新增
          const newIsMobile = currentWidth <= 768
          const newShowNav = currentWidth > 997
          if (this.isMobile !== newIsMobile) {
            this.isMobile = newIsMobile
          }
          if (this.showNav !== newShowNav) {
            const previousShowNav = this.showNav
            this.showNav = newShowNav
            if (!previousShowNav && newShowNav && this.currentArticle) {
              this.$nextTick(() => {
                this.parseHeadings()
              })
            }
          }
          this.$nextTick(() => {
            try {
              const nav = document.querySelector('.section-nav')
              if (nav) {
                if (currentWidth <= 1700) {
                  nav.classList.remove('show')
                  if (nav.style.display === 'block') {
                    nav.style.display = ''
                  }
                  this.navOpen = false
                } else {
                  nav.classList.remove('show')
                  this.navOpen = false
                }
              }
            } catch (navError) {
              console.warn('导航状态重置失败:', navError)
            }
          })
        }, 100)
      } catch (error) {
        console.error('窗口大小变化处理失败:', error)
      }
    },

    // 调整导航位置（已禁用，使用CSS固定定位）
    adjustNavigationPosition() {
      // 服务端渲染时直接返回
      if (this.$isServer) return
      // 不再动态调整位置，完全依赖CSS定位
      return
    },

    sectionNavFun() {
      this.$nextTick(() => {
        const nav = document.querySelector('.section-nav')
        if (!nav) return
        const screenWidth = this.windowWidth
        console.log(this.windowWidth, '___', screenWidth)
        if (screenWidth <= 1700) {
          const isOpen = nav.classList.contains('show')
          nav.classList.toggle('show')
          this.navOpen = !isOpen
        }
        // 桌面端不做任何显示/隐藏操作
      })
    },

    // 获取当前文章内容对象
    getCurrentArticleContentObj() {
      const list = document.querySelectorAll('.content_st')
      return list[this.activeIndex]
    },

    // 获取滚动容器（用于章节导航）
    getContainer() {
      if (this.$isServer) return
      // 返回页面的主要滚动容器
      return document.querySelector('.contenta') || window
    },

    // 解析文章内容中的标题
    parseHeadings() {
      if (this.$isServer) return

      // 使用双重$nextTick确保DOM完全更新
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.headings = []
          const content = this.getCurrentArticleContentObj()

          if (!content) {
            return
          }

          // 查找所有标题元素，包括在嵌套容器中的
          const headingElements = content.querySelectorAll('h1, h2, h3, h4, h5, h6')

          headingElements.forEach((el, index) => {
            // 为标题设置唯一ID，避免冲突
            const headingId = `heading-${this.activeIndex}-${index}`
            el.id = headingId

            // 移除scroll-margin-top，让我们的JavaScript控制滚动位置
            el.style.scrollMarginTop = '0px'

            this.headings.push({
              id: headingId,
              title: el.textContent.trim(),
              level: parseInt(el.tagName.charAt(1))
            })
          })

          // 解析完标题后，初始化激活状态
          this.$nextTick(() => {
            if (this.headings.length > 0) {
              // 设置第一个标题为默认激活状态
              this.activeHeading = this.headings[0].id
              this.updateNavActiveState(this.headings[0].id)

              // 触发一次滚动处理以确保状态正确
              this.handleScroll()
            }
          })
        })
      })
    },

    // 生成唯一ID（兼容异常数据）[4](@ref)
    generateUUID() {
      // 使用简单的计数器生成稳定的ID，避免随机值导致SSR水合不匹配
      if (!this._uuidCounter) {
        this._uuidCounter = 0
      }
      this._uuidCounter++
      return `generated-id-${this._uuidCounter}`
    },
    init() {
      const that = this
      const adParam = 'alias=newsinfo_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          if (res.result.length > 0) {
            that.banners = res.result[0]
          }
        }
      })
      // that.getNowDate()//获取当前时间
      that.getCompetitionInfo()

      that.addBrowserAndBookmark()
    },
    // changeEvent(e) {
    //   const that = this
    //   that.event = e
    //   // that.info = that.competition.info[that.event]
    // },
    // changeEvent(index) {
    //   const that = this
    //   that.currentEvent = index
    //   // that.info = that.competition.info[that.event]
    // },
    // 修改事件处理
    changeEvent(item, index) {
      this.activeIndex = index

      // 切换标签页后需要重新解析标题
      this.$nextTick(() => {
        this.parseHeadings()
      })
    },
    addBrowserAndBookmark() {
      let id = this.$route.query.id
      if (!id) {
        id = this.$route.params.id
      }
      const param = 'type=1&competitionId=' + id + '&parentcompetitionId='
      addBrowser(param).then(res => {
        if (res.success) {
          // 预览添加成功
        }
      })
    },
    async getCompetitionInfo() {
      const that = this
      let id = this.$route.query.id
      if (!id) {
        id = this.$route.params.id
      }
      const param = 'id=' + id

      if (that.$store.state.sitiInfo == null || that.$store.state.sitiInfo == '') {
        message.error(that.globalDataArray.siteTemplateLanguage.system_data_empty_tips)

        let backPath = '/competition'
        if (this.$route.query.from) {
          backPath = '/competition?from=' + this.$route.query.from
        }

        this.$router.push({ path: backPath })
        return
      }

      // 获取banner上的状态
      getCompetitionInfo(param).then(async res => {
        if (res.success) {
          // 在存储到store之前处理数据
          const saitiStatusCont = res.result

          // 将utc时间转为当地时间并作比较
          const endUtcTime = saitiStatusCont.endUtcTime
          const localEndtimeStr = new Date(endUtcTime).getTime()
          saitiStatusCont['localEndtime'] = stringToDateTime(localEndtimeStr)
          saitiStatusCont['localEndtimeStr'] = localEndtimeStr

          const startUtcTime = saitiStatusCont.startUtcTime
          const localStarttimeStr = new Date(startUtcTime).getTime()
          saitiStatusCont['localStarttime'] = stringToDateTime(localStarttimeStr)

          // 数据处理逻辑（只有在数据未被处理时才处理，避免重复处理）
          // 如果从SSR来的数据已经是数组，则不再处理
          if (saitiStatusCont.mark && typeof saitiStatusCont.mark === 'string') {
            saitiStatusCont.mark = saitiStatusCont.mark.split(/[,，]/).filter(item => item.trim())
          }

          if (saitiStatusCont.organizersLogo && typeof saitiStatusCont.organizersLogo === 'string') {
            const organizersLogo = saitiStatusCont.organizersLogo
            saitiStatusCont.organizersLogo = organizersLogo.split(',').filter(item => item.trim())
          }

          if (saitiStatusCont.organizers && typeof saitiStatusCont.organizers === 'string') {
            const organizers = saitiStatusCont.organizers
            saitiStatusCont.organizers = organizers.split(',').filter(item => item.trim())
          }

          // 用户协议变更
          console.log('检查用户协议变更状态:', {
            hasAgreementUpdate: saitiStatusCont.hasAgreementUpdate,
            hasNoticeUpdate: saitiStatusCont.hasNoticeUpdate,
            competitionTemplateAssociation: saitiStatusCont.competitionTemplateAssociation
          })

          if (saitiStatusCont.hasAgreementUpdate === 1) {
            console.log('触发用户协议变更弹窗')
            that.curInfoArray.competitionTemplateAssociation = saitiStatusCont.competitionTemplateAssociation
            const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + saitiStatusCont.templateId
            const resNew = await queryByParentId(paTemp)
            if (resNew.success) {
              that.$store.commit('updateModalState', { key: 'agreementContent', value: that.decodeHtmlEntities(resNew.result.agreementContent || '') })
              that.$store.commit('updateModalState', { key: 'noticeContent', value: that.decodeHtmlEntities(resNew.result.noticeContent || '') })
              that.$store.commit('updateModalState', { key: 'formxieyi', value: true })
              console.log('用户协议弹窗已设置')
            }
          }
          if (saitiStatusCont.hasNoticeUpdate === 1 && saitiStatusCont.hasAgreementUpdate !== 1) {
            console.log('触发参赛须知变更弹窗')
            that.curInfoArray.competitionTemplateAssociation = saitiStatusCont.competitionTemplateAssociation
            const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + saitiStatusCont.templateId
            const resNew = await queryByParentId(paTemp)
            if (resNew.success) {
              that.$store.commit('updateModalState', { key: 'agreementContent', value: that.decodeHtmlEntities(resNew.result.agreementContent || '') })
              that.$store.commit('updateModalState', { key: 'noticeContent', value: that.decodeHtmlEntities(resNew.result.noticeContent || '') })
              that.$store.commit('updateModalState', { key: 'formEntry', value: true })
              console.log('参赛须知弹窗已设置')
            }
          }

          // 处理完数据后存储到store
          that.$store.commit('setSaitiStatusCont', saitiStatusCont)
          that.getSignupTemplate()

          // 同步状态到store
          this.$store.commit('updateModalState', { key: 'hasAgreementUpdate', value: saitiStatusCont.hasAgreementUpdate })
          this.$store.commit('updateModalState', { key: 'hasNoticeUpdate', value: saitiStatusCont.hasNoticeUpdate })
          that.gitUrl = saitiStatusCont.gitUrl

          // 确保curInfoArray状态正确设置
          if (saitiStatusCont.hasAgreementUpdate === 1 || saitiStatusCont.hasNoticeUpdate === 1) {
            that.curInfoArray.competitionTemplateAssociation = saitiStatusCont.competitionTemplateAssociation
            console.log('已设置competitionTemplateAssociation:', that.curInfoArray.competitionTemplateAssociation)
          }
        }
      })
      that.competition = that.$store.state.sitiInfo
      if (that.competition) {
        that.competition.info.forEach((item, index) => {
          if (item.title === '作品介绍') {
            const params = 'competitionId=' + this.$route.query.id
            fetchWorkInfo().then(res => {
              if (res.success && res.result?.records[0]?.gitUrl) {
                this.gitUrl = res.result.records[0].gitUrl
              }
              if (res.success && res.result?.records[0]?.id) {
                this.teamNo = res.result.records[0].id
              }
            })
          }
        })
      }
      that.info = that.competition.info?.[that.event]

      // 筛选三种状态  过去  距离现在最近  未来
      const progress = that.competition.progress
      const curProgress = []
      progress.forEach((item, index) => {
        const pStartUtcDate = item.startUtcDate
        const pStartLocalStr = new Date(pStartUtcDate).getTime()
        item['pStartLocalStr'] = pStartLocalStr

        if (that.$store.state.currentTime > pStartLocalStr) {
          curProgress.push(Number(pStartLocalStr))
        } else {
          item['progressStatus'] = '2'
        }
      })

      // 打散获取最大值
      const mathMax = Math.max(...curProgress)

      progress.forEach((item, index) => {
        if (item.pStartLocalStr == mathMax) {
          item['progressStatus'] = '1'
        } else if (item.progressStatus != 2) {
          item['progressStatus'] = '0'
        }
      })
    },

    // 获取用户协议和参赛须知
    getSignupTemplate() {
      const that = this
      const currentLanguage = this.getCurrentLanguage()

      // 初始化默认的articles数组，确保用户协议和参赛须知始终显示
      const defaultArticles = [
        {
          id: 'default_agreement',
          title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
          content: '',
          type: 'agreement'
        },
        {
          id: 'default_notice',
          title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
          content: '',
          type: 'notice'
        }
      ]

      // 先设置默认内容，确保UI始终显示
      that.articles = defaultArticles

      if (this.saitiStatusCont.signup === '04') {
        const pa = 'competitionId=' + this.$route.query.id + '&language=' + currentLanguage
        historyQueryById(pa).then(res => {
          if (res.success) {
            const articles = []

            // 添加协议数据
            if (res.result.agreementId && res.result.agreementContext) {
              articles.push({
                id: res.result.agreementId,
                title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
                content: that.decodeHtmlEntities(res.result.agreementContext),
                type: 'agreement'
              })
            } else {
              // 如果没有协议数据，使用默认的
              articles.push(defaultArticles[0])
            }

            // 添加通知数据
            if (res.result.noticeId && res.result.noticeContext) {
              articles.push({
                id: res.result.noticeId,
                title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
                content: that.decodeHtmlEntities(res.result.noticeContext),
                type: 'notice'
              })
            } else {
              // 如果没有通知数据，使用默认的
              articles.push(defaultArticles[1])
            }

            // 只更新本地数据，避免不同比赛数据相互干扰
            that.articles = articles
          } else {
            // 如果 res.success 为 false，直接调用模板签名方法
            that.getTemplateSignup(currentLanguage)
          }
        }).catch(() => {
          // 如果 historyQueryById 失败，直接调用模板签名方法
          that.getTemplateSignup(currentLanguage)
        })
      } else {
        that.getTemplateSignup(currentLanguage)
      }
    },

    // 获取模板签名的逻辑
    getTemplateSignup(currentLanguage) {
      const that = this
      const param = 'templateId=' + that.competition.templateId + '&language=' + currentLanguage
      getSignupTemplate(param).then(res => {
        if (res.success) {
          const articles = []

          // 添加协议数据
          if (res.result.agreementId && res.result.agreementContent) {
            articles.push({
              id: res.result.agreementId,
              title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
              content: that.decodeHtmlEntities(res.result.agreementContent),
              type: 'agreement'
            })
          } else {
            // 如果没有协议数据，使用默认的
            articles.push({
              id: 'default_agreement',
              title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
              content: '',
              type: 'agreement'
            })
          }

          // 添加通知数据
          if (res.result.noticeId && res.result.noticeContent) {
            articles.push({
              id: res.result.noticeId,
              title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
              content: that.decodeHtmlEntities(res.result.noticeContent),
              type: 'notice'
            })
          } else {
            // 如果没有通知数据，使用默认的
            articles.push({
              id: 'default_notice',
              title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
              content: '',
              type: 'notice'
            })
          }

          // 只更新本地数据，避免不同比赛数据相互干扰
          that.articles = articles
        } else {
          // 如果 res.success 为 false，设置默认的空内容
          const fallbackArticles = [
            {
              id: 'fallback_agreement',
              title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
              content: '',
              type: 'agreement'
            },
            {
              id: 'fallback_notice',
              title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
              content: '',
              type: 'notice'
            }
          ]
          that.articles = fallbackArticles
        }
      }).catch(() => {
        // 如果API调用失败，确保本地数据至少有空内容的占位符
        const fallbackArticles = [
          {
            id: 'fallback_agreement',
            title: that.globalDataArray.siteTemplateLanguage.user_agreement || '用户协议',
            content: '',
            type: 'agreement'
          },
          {
            id: 'fallback_notice',
            title: that.globalDataArray.siteTemplateLanguage.join_notice || '参赛须知',
            content: '',
            type: 'notice'
          }
        ]
        that.articles = fallbackArticles
      })
    },
    // 提交作品处理
    async handleSubmitWork(record) {
      this.queryId = this.getQueryParam('id')

      const response = await getCompetitionInfo(`id=${this.queryId}`)

      if (record.gitUrl) {
        window.open(record.gitUrl, '_blank')
      }

      if (response.result.webCheckStatus !== '03') {
        console.log('======> response', response)
        this.$message.error(this.globalDataArray.siteTemplateLanguage.review_submitted)
      }
      else if (this.saitiStatusCont.competitionAtomgitOrgInfo) {
        const token = localStorage.getItem('atomgit_oauth_access_token') || ''

        if (!token) {
          this.$router.push({
            path: '/login',
            query: { from: this.$route.fullPath }
          })
          return
        }

        const atomgitOrgInfo = JSON.parse(this.saitiStatusCont.competitionAtomgitOrgInfo)
        console.log('======> atomgitOrgInfo', atomgitOrgInfo)
        const param = {
          targetOrgId: atomgitOrgInfo.orgId,
          description: atomgitOrgInfo.teamName,
          name: atomgitOrgInfo.teamName,
          path: atomgitOrgInfo.id,
          id: atomgitOrgInfo.id,
          oauthToken: token,
          targetOrgPath: atomgitOrgInfo.orgCode
        }

        const res = await createAtomGitRepo(param)

        if (res.success) {
          await this.getCompetitionInfo()
          window.open(res.result, '_blank')
        }
        else if (res.code == 510) {
          this.$router.push({
            path: '/login',
            query: { from: this.$route.fullPath }
          })
        }
        else {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.create_repository_failed || '创建仓库失败，请联系承办方')
        }
      }
      else {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.review_submitteds)
      }
    },

    async toSignFun(saitiStatusCont) {
      const that = this
      that.curInfoArray.templateId = saitiStatusCont.templateId
      that.curInfoArray.categoryId = saitiStatusCont.categoryId // 当前赛题分类id
      that.curInfoArray.competitionId = saitiStatusCont.parentId // 当前赛题id
      that.curInfoArray.inviteId = that.inviteId // 邀请ID
      that.curInfoArray.teamsUsers = saitiStatusCont.teamsUsers // 当前赛题限制成员数
      that.curInfoArray.teams = saitiStatusCont.teams
      that.curInfoArray.parentId = saitiStatusCont.parentId
      that.curInfoArray.zoneId = saitiStatusCont.zoneId
      that.curInfoArray.agreementId = saitiStatusCont.agreementId
      that.curInfoArray.noticeId = saitiStatusCont.noticeId
      that.curInfoArray.qrImage = saitiStatusCont.qrImage
      if (Cookies.get('DEFAULT_LANG') != '' && Cookies.get('DEFAULT_LANG') != undefined) {
        that.curInfoArray.currentLanguge = Cookies.get('DEFAULT_LANG')
      } else {
        that.curInfoArray.currentLanguge = 'zh_CN'
      }

      // this.formteen=true

      let token = ''
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
      }
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + saitiStatusCont.templateId
      const res = await queryByParentId(paTemp)
      if (res.success) {
        this.$store.commit('updateModalState', {
          key: 'agreementContent',
          value: this.decodeHtmlEntities(res.result.agreementContent || '')
        })
        this.$store.commit('updateModalState', {
          key: 'noticeContent',
          value: this.decodeHtmlEntities(res.result.noticeContent || '')
        })
      }
      if (token != '' && token != undefined) {
        this.$store.commit('updateModalState', { key: 'formxieyi', value: true })
      } else {
        that.handleLogin()
        // message.error(that.globalDataArray.siteTemplateLanguage.please_login)
      }
    },
    // 选择报名方式
    signtypeFun(res) {
      // 自定义事件，把item传给父组件,发射事件
      if (res === '1') {
        this.$store.commit('updateModalState', { key: 'formsign', value: true })
      }

      if (res === '2') { // 加入团队
        this.$store.commit('updateModalState', { key: 'formapply', value: true })
      }
    },

    formsignFun(num) {
      if (num === '1') { // 立即报名
        message.success(this.globalDataArray.siteTemplateLanguage.competition_signup_success_tips)
        // 报名成功改变按钮状态
        this.updateSaitiStatusCont('isSignup', '2')

        if (this.saitiStatusCont.teams != null && this.saitiStatusCont.teams != '') {
          this.updateSaitiStatusCont('teams', this.saitiStatusCont.teams + 1)
        } else {
          this.updateSaitiStatusCont('teams', '1')
        }
        this.$store.commit('updateModalState', { key: 'qrCode', value: true })
      }
    },

    formapplyFun(res) {
      if (res.clickType == '1') { // 加入
        this.teamArray = res
        this.$store.commit('updateModalState', { key: 'formmsg', value: true })
      }

      if (res.clickType == '2') { // 取消、关闭
        // 取消或关闭
      }
    },

    formmsgFun(res) {
      if (res == '1') { // 确认
        this.$store.commit('updateModalState', { key: 'qrCode', value: true })

        // 报名成功改变按钮状态
        this.updateSaitiStatusCont('isSignup', '2')
      }

      if (res == '2') { // 取消、关闭
        this.$store.commit('updateModalState', { key: 'formapply', value: true })
      }
    },

    async formxieyiFun(res) {
      if (res === '1' && this.modalStates.hasAgreementUpdate === 1) {
        const params = structuredClone(this.curInfoArray.competitionTemplateAssociation)
        delete params.noticeId
        const resNew = await UpdateCompetitionTemplateAssociation(params)
        if (resNew.success) {
          // 协议更新成功
        }
        if (this.modalStates.hasNoticeUpdate === 1) {
          this.$store.commit('updateModalState', { key: 'formEntry', value: true })
        }
        this.$store.commit('updateModalState', { key: 'hasAgreementUpdate', value: '' })
        return
      }

      if (res === '1') { // 同意
        this.$store.commit('updateModalState', { key: 'formEntry', value: true })
      }
    },
    async formEntryFun(res) {
      if (res === '1' && this.modalStates.hasNoticeUpdate === 1) {
        const params = structuredClone(this.curInfoArray.competitionTemplateAssociation)
        delete params.agreementId
        const resNew = await UpdateCompetitionTemplateAssociation(params)
        if (resNew.success) {
          // 参数须知更新成功
          this.curInfoArray.competitionTemplateAssociation = {}
        }
        this.$store.commit('updateModalState', { key: 'hasNoticeUpdate', value: '' })
        return
      }
      if (res === '1') {
        this.$store.commit('updateModalState', { key: 'signway', value: true })
      }
    },

    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.openatom.tech', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },

    goTopFun() {
      if (typeof document === 'object') {
        const scrollToptimer = setInterval(function() {
          // console.log("定时循环回到顶部");
          var top = document.body.scrollTop || document.documentElement.scrollTop
          var speed = top / 4
          document.documentElement.scrollTop -= speed
          if (top == 0) {
            clearInterval(scrollToptimer)
          }
        }, 30)
      }
    },
    addSource(source) {
      addSource({ source: source }).then(res => {
        if (!res.success) {
          message.error(res.message)
        }
      })
    },

    submitForm() {
      const that = this
      that.$refs['ruleContentForm'].validate(valid => {
        if (valid) {
          const params = that.ruleContentForm
          params.competitionId = that.id
          addSubscription(params).then(res => {
            if (res.success) {
              message.success('订阅成功！')
              that.ruleContentForm = {
                name: undefined,
                email: undefined
              }
            } else {
              message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    handleKeyDown(e) {
      e.preventDefault() // 阻止所有键盘输入
    },
    openUrl(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    // 更新store中的saitiStatusCont字段
    updateSaitiStatusCont(field, value) {
      const currentStatus = { ...this.$store.state.saitiStatusCont }
      currentStatus[field] = value
      this.$store.commit('setSaitiStatusCont', currentStatus)
    },

    // 获取当前语言
    getCurrentLanguage() {
      // 优先使用Cookie中的语言设置
      const cookieLang = Cookies.get('DEFAULT_LANG')
      if (cookieLang) {
        return cookieLang
      }

      // 其次使用全局语言设置
      if (this.globalDataArray && this.globalDataArray.siteInfo && this.globalDataArray.siteInfo.language) {
        return this.globalDataArray.siteInfo.language
      }

      // 默认返回中文
      return 'zh_CN'
    },

    // 节流滚动监听
    handleScrollThrottle: function() {
      // 只有在非导航动画期间才处理滚动事件
      if (!this.isNavigating) {
        cancelAnimationFrame(this.scrollFrame)
        this.scrollFrame = requestAnimationFrame(this.handleScroll)
      }
    },

    // 计算页面顶部偏移量
    getPageTopOffset() {
      if (this.$isServer) return 80

      let topOffset = 0

      // 计算页面顶部各个区域的高度
      const banner = document.querySelector('.banner')
      const question = document.querySelector('.question')

      if (banner) {
        topOffset += banner.offsetHeight
      }
      if (question) {
        topOffset += question.offsetHeight
      }

      // 内容区域距离顶部的实际偏移量（更精确的计算）
      const contentArea = document.querySelector('.contenta')
      if (contentArea) {
        const contentRect = contentArea.getBoundingClientRect()
        const currentScrollTop = window.scrollY || document.documentElement.scrollTop
        const contentTop = contentRect.top + currentScrollTop
        topOffset = Math.max(topOffset, contentTop)
      }

      return topOffset
    },

    // 计算章节内容在视口中的可见比例
    calculateSectionVisibility(sectionStart, sectionEnd, viewportTop, viewportBottom) {
      // 章节在视口中的可见部分
      const visibleStart = Math.max(sectionStart, viewportTop)
      const visibleEnd = Math.min(sectionEnd, viewportBottom)

      if (visibleStart >= visibleEnd) {
        return 0 // 完全不可见
      }

      const visibleHeight = visibleEnd - visibleStart
      const sectionHeight = sectionEnd - sectionStart
      const viewportHeight = viewportBottom - viewportTop

      // 计算可见比例，优先考虑占据视口比例
      const viewportRatio = visibleHeight / viewportHeight
      const sectionRatio = visibleHeight / sectionHeight

      // 使用加权平均，更偏向于占据视口比例高的章节
      const weightedRatio = (viewportRatio * 0.7) + (sectionRatio * 0.3)

      return Math.min(weightedRatio, 1) // 确保比例不超过1
    },

    // 处理滚动事件（基于内容占比的精确定位）
    handleScroll() {
      if (this.$isServer || !this.headings.length) return

      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight
      const viewportTop = scrollTop
      const viewportBottom = scrollTop + viewportHeight

      // 动态获取页面顶部偏移量
      const pageTopOffset = this.getPageTopOffset()

      let maxVisibility = 0
      let mostVisibleHeading = ''

      // 计算每个章节的可见性比例
      for (let i = 0; i < this.headings.length; i++) {
        const currentElement = document.getElementById(this.headings[i].id)
        if (!currentElement) continue

        // 获取当前章节标题的真实位置
        const currentRect = currentElement.getBoundingClientRect()
        // 章节内容从标题开始（但要考虑标题本身的高度）
        const titleBottom = currentRect.bottom + scrollTop
        let sectionStart = titleBottom // 从标题底部开始计算内容

        // 获取章节内容结束位置（下一个标题位置或内容区域底部）
        let sectionEnd
        if (i < this.headings.length - 1) {
          const nextElement = document.getElementById(this.headings[i + 1].id)
          if (nextElement) {
            const nextRect = nextElement.getBoundingClientRect()
            sectionEnd = nextRect.top + scrollTop // 到下一个标题的顶部
          } else {
            // 如果找不到下一个元素，使用内容区域底部
            const contentElement = this.getCurrentArticleContentObj()
            sectionEnd = contentElement ? (contentElement.getBoundingClientRect().bottom + scrollTop) : (scrollTop + viewportHeight * 2)
          }
        } else {
          // 最后一个章节，使用内容区域底部
          const contentElement = this.getCurrentArticleContentObj()
          if (contentElement) {
            const contentRect = contentElement.getBoundingClientRect()
            sectionEnd = contentRect.bottom + scrollTop
          } else {
            sectionEnd = document.documentElement.scrollHeight
          }
        }

        // 确保章节至少有合理的高度，否则使用标题位置进行判断
        if (sectionEnd - sectionStart < 50) {
          // 对于内容很少的章节，使用标题位置来判断
          const titleTop = currentRect.top + scrollTop
          sectionStart = titleTop - 100 // 标题上方100px开始
          sectionEnd = titleTop + 300 // 标题下方300px结束
        }

        // 计算该章节的可见性比例
        const visibility = this.calculateSectionVisibility(
          sectionStart,
          sectionEnd,
          viewportTop,
          viewportBottom
        )

        // 对于章节较短但恰好在视口中心的情况，给予额外权重
        const titleInViewport = currentRect.top >= 0 && currentRect.bottom <= viewportHeight
        const titleNearCenter = Math.abs(currentRect.top + currentRect.height / 2 - viewportHeight / 2) < viewportHeight * 0.3

        let finalVisibility = visibility
        if (titleInViewport && titleNearCenter) {
          finalVisibility = Math.max(visibility, 0.6) // 确保标题在视口中心附近时有足够权重
        }

        // 找到可见性最高的章节
        if (finalVisibility > maxVisibility) {
          maxVisibility = finalVisibility
          mostVisibleHeading = this.headings[i].id
        }
      }

      // 如果没有找到可见的章节，使用备用策略
      if (!mostVisibleHeading || maxVisibility < 0.1) {
        // 备用策略1：找到当前滚动位置之前最近的标题
        for (let i = this.headings.length - 1; i >= 0; i--) {
          const element = document.getElementById(this.headings[i].id)
          if (element) {
            const elementRect = element.getBoundingClientRect()
            const elementTop = elementRect.top + scrollTop

            if (elementTop <= scrollTop + pageTopOffset + 150) {
              mostVisibleHeading = this.headings[i].id
              break
            }
          }
        }

        // 备用策略2：如果用户在页面内容区域最顶部，使用第一个标题
        if (!mostVisibleHeading && scrollTop < pageTopOffset + 200 && this.headings.length > 0) {
          mostVisibleHeading = this.headings[0].id
        }

        // 备用策略3：如果用户在页面最底部，使用最后一个标题
        if (!mostVisibleHeading && (viewportTop + viewportHeight) >= (document.documentElement.scrollHeight - 100)) {
          mostVisibleHeading = this.headings[this.headings.length - 1].id
        }
      }

      // 更新激活状态（只有在非导航状态下才更新）
      if (mostVisibleHeading && mostVisibleHeading !== this.activeHeading && !this.isNavigating) {
        this.activeHeading = mostVisibleHeading
        // 滚动时只更新内部状态，不更新URL
        // this.updateNavActiveState(mostVisibleHeading)
      }
    },

    // 更新导航激活状态（简化版本）
    updateNavActiveState(headingId) {
      if (this.$isServer) return

      // 更新 URL hash
      const newHash = `#${headingId}`
      if (window.location.hash !== newHash) {
        window.history.replaceState(null, null, newHash)
      }

      // 更新内部状态
      this.activeHeading = headingId
    },

    // 切换移动端目录
    toggleToc() {
      this.tocExpanded = !this.tocExpanded
    },

    // 处理移动端目录点击
    handleTocClick(heading) {
      if (this.$isServer) return

      // 防抖处理：如果点击间隔太短，延迟处理
      const currentTime = Date.now()
      if (currentTime - this.lastClickTime < this.clickDebounceDelay) {
        // 清除之前的定时器
        if (this.navigationTimer) {
          clearTimeout(this.navigationTimer)
        }

        // 延迟执行真正的点击处理
        this.navigationTimer = setTimeout(() => {
          this.performNavigation(heading)
        }, this.clickDebounceDelay)
        return
      }

      this.lastClickTime = currentTime
      this.performNavigation(heading)
    },

    // 执行实际的导航操作
    performNavigation(heading) {
      const element = document.getElementById(heading.id)
      if (!element) return

      // 清除所有之前的定时器和状态
      if (this.navigationTimer) {
        clearTimeout(this.navigationTimer)
        this.navigationTimer = null
      }

      // 立即更新激活状态
      this.activeHeading = heading.id
      this.isNavigating = true

      // 立即更新视觉状态
      this.updateNavActiveState(heading.id)

      // 使用更简单的滚动方式，让标题出现在视口顶部
      const elementRect = element.getBoundingClientRect()
      const currentScrollTop = window.scrollY || document.documentElement.scrollTop
      const elementTop = elementRect.top + currentScrollTop

      // 使用固定的偏移量，确保标题不会被顶部区域遮挡
      const fixedOffset = 100 // 固定200px偏移量，避免被banner等遮挡
      const targetScrollTop = elementTop - fixedOffset

      // 平滑滚动到目标位置
      window.scrollTo({
        top: Math.max(0, targetScrollTop),
        behavior: 'smooth'
      })

      // 收起移动端目录
      if (this.isMobile) {
        this.tocExpanded = false
      }

      // 设置较短的恢复时间，减少状态锁定时间
      this.navigationTimer = setTimeout(() => {
        this.isNavigating = false
        this.navigationTimer = null
        // 最终确保状态正确
        this.updateNavActiveState(heading.id)
      }, 800)
    },

    // 处理导航点击事件 (替换原来的 handleAnchorClick)
    handleNavClick(heading) {
      if (this.$isServer) return

      // 防抖处理：如果点击间隔太短，延迟处理
      const currentTime = Date.now()
      if (currentTime - this.lastClickTime < this.clickDebounceDelay) {
        // 清除之前的定时器
        if (this.navigationTimer) {
          clearTimeout(this.navigationTimer)
        }

        // 延迟执行真正的点击处理
        this.navigationTimer = setTimeout(() => {
          this.performNavigation(heading)
        }, this.clickDebounceDelay)
        return
      }

      this.lastClickTime = currentTime
      this.performNavigation(heading)
    },

    // 获取订阅标题（支持可选的比赛名称变量替换）
    getSubscriptionTitle() {
      const template = this.globalDataArray.siteTemplateLanguage.subscription_competition_title	 || '订阅比赛更新'

      // 检查模板中是否包含 {competitionTitle} 变量
      if (template.includes('{competitionTitle}')) {
        // 获取比赛标题
        const competitionTitle = this.saitiStatusCont?.title || this.$store.state.sitiInfo?.title || '比赛'
        // 替换变量
        return template.replace('{competitionTitle}', competitionTitle)
      }

      // 如果没有变量，直接返回原模板
      return template
    },

    // 点击外部区域关闭导航
    handleClickOutside(event) {
      if (this.$isServer || window.innerWidth > 997) return

      const nav = document.querySelector('.section-nav')
      const navBtn = document.querySelector('.mobile-section-nav-btn')

      if (!nav || !navBtn) return

      // 检查点击是否在导航或按钮内部
      const isClickInsideNav = nav.contains(event.target)
      const isClickInsideBtn = navBtn.contains(event.target)

      // 如果点击在外部且导航是打开的，则关闭导航
      if (!isClickInsideNav && !isClickInsideBtn && nav.classList.contains('show')) {
        nav.classList.remove('show')
        this.navOpen = false
      }
    }

  },
  metaInfo() {
    let title = this.globalDataArray.siteInfo.title
    let description = this.globalDataArray.siteInfo.description
    let keywords = this.globalDataArray.siteInfo.keywords
    if (this.$store.state.sitiInfo != '' && this.$store.state.sitiInfo != null) {
      if (this.$store.state.sitiInfo.title != '' && this.$store.state.sitiInfo.title != null) {
        title = this.$store.state.sitiInfo.title + '-' + this.globalDataArray.siteInfo.title
      }
      if (this.$store.state.sitiInfo.description != '' && this.$store.state.sitiInfo.description != null) {
        description = this.$store.state.sitiInfo.description
      }
      if (this.$store.state.sitiInfo.keywords != '' && this.$store.state.sitiInfo.keywords != null) {
        keywords = this.$store.state.sitiInfo.keywords
      }
    }
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>

<!-- ==================== 全局表格样式 - GitHub风格 ==================== -->
<!-- 非scoped样式，确保能够作用到v-html渲染的表格内容 -->
<style lang="scss">
/* Markdown内容区域的表格样式 - 简洁高效 */
.markdown-content table {
  /* 基础表格重置和GitHub风格样式 */
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100% !important;
  margin: 16px 0 !important;
  background-color: #fff !important;
  border: 1px solid #d0d7de !important;
  border-radius: 6px !important;
  overflow: hidden !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  color: #24292f !important;

  /* 确保在SSR环境下正确渲染 */
  box-sizing: border-box !important;
  display: table !important;
}

/* 表格头部样式 - GitHub设计 */
.markdown-content table thead,
.markdown-content table thead tr {
  background-color: #f6f8fa !important;
  border-bottom: 2px solid #d0d7de !important;
}

/* 表头单元格样式 */
.markdown-content table th {
  padding: 12px 16px !important;
  text-align: left !important;
  font-weight: 600 !important;
  color: #24292f !important;
  background-color: #f6f8fa !important;
  border: 1px solid #d0d7de !important;
  border-bottom: 2px solid #d0d7de !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
}

/* 表格主体样式 */
.markdown-content table tbody {
  background-color: #fff !important;
}

/* 表格行样式 - 斑马纹效果 */
.markdown-content table tbody tr {
  border-bottom: 1px solid #d0d7de !important;
  transition: background-color 0.2s ease !important;
}

/* 偶数行背景色 - 斑马纹 */
.markdown-content table tbody tr:nth-child(even) {
  background-color: #f6f8fa !important;
}

/* 悬停效果 */
.markdown-content table tbody tr:hover {
  background-color: #eef4fd !important;
}

/* 表格数据单元格样式 */
.markdown-content table td {
  padding: 8px 16px !important;
  border: 1px solid #d0d7de !important;
  color: #24292f !important;
  background-color: inherit !important;
  vertical-align: top !important;
  word-wrap: break-word !important;
  max-width: 300px !important;
  overflow-wrap: break-word !important;
}

/* 通用链接样式 - 默认使用蓝色 */
.markdown-content a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 有颜色父级容器时，链接继承颜色 */
.markdown-content [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.markdown-content a:hover {
  text-decoration: none !important;
  border-bottom: 1px solid currentColor !important;
}

/* 表格内链接样式 - 继承通用样式 */
.markdown-content table a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 表格内有颜色父级容器时，链接继承颜色 */
.markdown-content table [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.markdown-content table a:hover {
  border-bottom: 1px solid currentColor !important;
  text-decoration: none !important;
}

/* 表格内代码样式 */
.markdown-content table code {
  background-color: #f3f4f6 !important;
  color: #24292f !important;
  padding: 2px 6px !important;
  border-radius: 3px !important;
  font-size: 13px !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  border: none !important;
}

/* 表格内强调文本样式 */
.markdown-content table strong,
.markdown-content table b {
  font-weight: 600 !important;
  color: #24292f !important;
}

/* 表格内斜体样式 */
.markdown-content table em,
.markdown-content table i {
  font-style: italic !important;
  color: #656d76 !important;
}

/* ==================== 响应式适配 ==================== */

/* 大屏幕优化 (1200px+) */
@media screen and (min-width: 1200px) {
  .markdown-content table {
    font-size: 15px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 12px 20px !important;
  }
}

/* 中等屏幕 (768px - 1199px) */
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .markdown-content table {
    font-size: 14px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 10px 14px !important;
    max-width: 250px !important;
  }
}

/* 移动端适配 (768px以下) */
@media screen and (max-width: 768px) {
  /* 覆盖problem_des.css中的强制字体样式 */
  .markdown-content table,
  .markdown-content table * {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  /* 移动端表格容器 - 横向滚动 */
  .markdown-content {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* 移动端表格样式调整 */
  .markdown-content table {
    min-width: 500px !important; /* 确保表格有最小宽度 */
    margin: 12px 0 !important;
    border-radius: 4px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 6px 10px !important;
    max-width: 150px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* 移动端表头样式 */
  .markdown-content table th {
    font-size: 11px !important;
    font-weight: 600 !important;
    padding: 8px 10px !important;
  }
}

/* 超小屏幕 (480px以下) */
@media screen and (max-width: 480px) {
  .markdown-content table {
    font-size: 11px !important;
    min-width: auto !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 4px 8px !important;
    max-width: 120px !important;
    font-size: 10px !important;
  }
}

/* ==================== 特殊情况处理 ==================== */

/* 处理可能的表格嵌套情况 */
.markdown-content table table {
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}

/* 处理空表格的情况 */
.markdown-content table:empty {
  display: none !important;
}

/* 确保表格在flex容器中正确显示 */
.content-wrapper .markdown-content table,
.content_st .markdown-content table {
  flex-shrink: 0 !important;
}

/* Marked v15.0.7 特殊HTML结构兼容 */
.markdown-content table > thead > tr > th,
.markdown-content table > tbody > tr > td,
.markdown-content table > tr > th,
.markdown-content table > tr > td {
  /* 确保兼容Marked可能输出的各种表格结构 */
  border: 1px solid #d0d7de !important;
  padding: 8px 16px !important;
}

</style>

<!-- ==================== Toast UI Editor 一致性表格样式 ==================== -->
<!-- 非scoped样式，确保能够作用到v-html渲染的表格内容 -->
<style lang="scss">
/* 简洁的Markdown内容表格样式 - 与Toast UI Editor预览保持一致 */
.markdown-content table {
  /* 基础表格样式 - 与Toast UI Editor预览保持一致 */
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100% !important;
  margin: 16px 0 !important;
  background-color: #fff !important;

  /* 添加明显的外部边框 - 确保与编辑器预览一致 */
  border: 2px solid #ddd !important;

  /* 简单样式，不使用圆角等装饰 */
  border-radius: 0 !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  color: #333 !important;

  /* 确保在SSR环境下正确渲染 */
  box-sizing: border-box !important;
  display: table !important;
}

/* 表格头部样式 - 简单清晰 */
.markdown-content table thead,
.markdown-content table thead tr {
  background-color: #f8f9fa !important;
}

/* 表头单元格样式 - 与Toast UI Editor保持一致 */
.markdown-content table th {
  padding: 10px 12px !important;
  text-align: left !important;
  font-weight: bold !important;
  color: #333 !important;
  background-color: #f8f9fa !important;
  border: 1px solid #ddd !important;
  border-bottom: 2px solid #ddd !important;
  vertical-align: middle !important;
}

/* 表格主体样式 */
.markdown-content table tbody {
  background-color: #fff !important;
}

/* 表格行样式 - 简单边框，不使用斑马纹 */
.markdown-content table tbody tr {
  background-color: #fff !important;
}

/* 表格数据单元格样式 - 与编辑器预览保持一致 */
.markdown-content table td {
  padding: 10px 12px !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
  background-color: #fff !important;
  vertical-align: top !important;
  word-wrap: break-word !important;
}

/* 表格内链接样式 - 简单蓝色链接 */
.markdown-content table a {
  color: #007bff !important;
  text-decoration: underline !important;
}

.markdown-content table a:hover {
  color: #0056b3 !important;
  text-decoration: underline !important;
}

/* 表格内代码样式 */
.markdown-content table code {
  background-color: #f1f3f4 !important;
  color: #333 !important;
  padding: 2px 4px !important;
  border-radius: 3px !important;
  font-size: 85% !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

/* 表格内强调文本样式 */
.markdown-content table strong,
.markdown-content table b {
  font-weight: bold !important;
  color: #333 !important;
}

/* 表格内斜体样式 */
.markdown-content table em,
.markdown-content table i {
  font-style: italic !important;
  color: #333 !important;
}

/* ==================== 响应式适配 - 保持一致性 ==================== */

/* 移动端适配 (768px以下) - 覆盖全局CSS但保持编辑器一致性 */
@media screen and (max-width: 768px) {
  /* 覆盖problem_des.css中的强制字体样式 */
  .markdown-content table,
  .markdown-content table * {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  /* 移动端表格容器 - 横向滚动 */
  .markdown-content {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* 移动端表格样式调整 */
  .markdown-content table {
    min-width: 500px !important; /* 确保表格有最小宽度 */
    margin: 12px 0 !important;
    font-size: 12px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 8px 10px !important;
    font-size: 12px !important;
  }
}

/* 超小屏幕 (480px以下) */
@media screen and (max-width: 480px) {
  .markdown-content table {
    font-size: 11px !important;
    min-width: auto !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 6px 8px !important;
    font-size: 11px !important;
  }
}

/* ==================== Toast UI Editor 兼容性处理 ==================== */

/* 确保Toast UI Editor渲染的表格结构正确显示 */
.markdown-content table > thead > tr > th,
.markdown-content table > tbody > tr > td,
.markdown-content table > tr > th,
.markdown-content table > tr > td {
  border: 1px solid #ddd !important;
  padding: 10px 12px !important;
}

/* 处理可能的表格嵌套情况 */
.markdown-content table table {
  margin: 0 !important;
  border: 1px solid #ddd !important;
}

/* 处理空表格的情况 */
.markdown-content table:empty {
  display: none !important;
}

</style>

<style scoped lang="scss">
@import "@/assets/css/problem_des.css";
.git-url-display {
  margin-bottom: 12px;
  .gita {
    color: #1890ff;
    margin-left: 12px;
  }
  .git-url-label {
    margin-right: 12px;
    line-height: 32px;
  }
}
.work-info-section {
  margin-top: 24px;
  .submit-work-btn {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
}
.work-info-section-new {
  text-align: right;
}
.git-input {
  cursor: pointer;
  width: 400px;
  margin: 0 12px 12px 0;
}

/* Markdown相关样式 */
.markdown-fallback {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
}

/* 错误处理和安全降级相关样式 */
.content-error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
  color: #ff4d4f;
}

.content-fallback {
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 12px;
  margin: 16px 0;
  color: #666;
}

.content-error-display {
  background: #fff1f0;
  border-left: 4px solid #ff4d4f;
  padding: 12px;
  margin: 8px 0;
  color: #cf1322;
}

/* 新增：DOM安全降级样式 */
.content-error-fallback {
  background: #fff2f0 !important;
  border: 1px solid #ffccc7 !important;
  border-radius: 6px !important;
  padding: 16px !important;
  margin: 16px 0 !important;
  color: #ff4d4f !important;
}

.content-error-fallback h4 {
  color: #ff4d4f !important;
  margin-bottom: 12px !important;
  font-size: 16px !important;
}

.content-error-fallback .error-message {
  color: #cf1322 !important;
  margin-bottom: 8px !important;
}

.content-error-fallback details {
  margin-top: 12px !important;
}

.content-error-fallback summary {
  cursor: pointer !important;
  color: #666 !important;
  font-size: 14px !important;
}

.content-error-fallback pre {
  background: #f5f5f5 !important;
  padding: 8px !important;
  margin-top: 8px !important;
  font-size: 12px !important;
  overflow: auto !important;
  border-radius: 4px !important;
}

/* CDN环境降级样式 */
.content-cdn-fallback {
  background: #f6ffed !important;
  border: 1px solid #b7eb8f !important;
  border-radius: 6px !important;
  padding: 16px !important;
  margin: 16px 0 !important;
}

.content-cdn-fallback h4 {
  color: #389e0d !important;
  margin-bottom: 12px !important;
  font-size: 16px !important;
}

.content-cdn-fallback .loading-message {
  color: #52c41a !important;
  margin-bottom: 8px !important;
}

.content-cdn-fallback .retry-prompt {
  margin-top: 12px !important;
}

.content-cdn-fallback .retry-prompt small {
  color: #666 !important;
}

.content-cdn-fallback .retry-prompt a {
  color: #1890ff !important;
  text-decoration: underline !important;
}

/* 安全模式降级样式 */
.content-safe-fallback {
  background: #f5f5f5 !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  padding: 16px !important;
  margin: 16px 0 !important;
}

.content-safe-fallback h4 {
  color: #333 !important;
  margin-bottom: 12px !important;
  font-size: 16px !important;
}

.content-safe-fallback p {
  color: #666 !important;
  line-height: 1.6 !important;
  margin-bottom: 8px !important;
}

.content-safe-fallback .fallback-note {
  margin-top: 12px !important;
}

.content-safe-fallback .fallback-note small {
  color: #999 !important;
  font-style: italic !important;
}

/* 确保内容区域正确显示空白字符 */
.txt.ck-content {
  white-space: pre-wrap; /* 保留空格和换行 */
  tab-size: 4; /* 设置tab显示宽度 */
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

.txt.ck-content pre,
.txt.ck-content code {
  white-space: pre-wrap;
  tab-size: 4;
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

.markdown-fallback pre {
  margin: 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  tab-size: 4; /* 设置tab显示为4个空格宽度 */
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

.markdown-error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
}

.markdown-error .error {
  color: #ff4d4f;
  font-weight: 500;
  margin-bottom: 12px;
}

.markdown-error details {
  margin-top: 12px;
}

.markdown-error summary {
  cursor: pointer;
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.markdown-error pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

/* 移动端本页总览样式 */
.mobile-toc-section {
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  margin: 16px;
  overflow: hidden;
  position: fixed;
  top: 80px;
  left: 16px;
  right: 16px;
  z-index: 1000;
}

.mobile-toc-title {
  background: #fff;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s ease;
}

.mobile-toc-title:hover {
  background-color: #f5f5f5;
}

.toc-toggle-icon {
  color: #999;
  transition: transform 0.3s ease;
}

.toc-toggle-icon.expanded {
  transform: rotate(180deg);
}

.mobile-toc-container {
  padding: 8px 0;
  max-height: 300px;
  overflow-y: auto;
  transition: all 0.3s ease;
  opacity: 1;
}

.mobile-toc-container.collapsed {
  max-height: 0;
  padding: 0;
  opacity: 0;
  overflow: hidden;
}

.mobile-toc-item {
  padding: 6px 12px;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
  transition: background-color 0.2s ease;
}

.mobile-toc-item:hover {
  background-color: #f0f0f0;
}

.mobile-toc-item:active {
  background-color: #e6f7ff;
}

.mobile-toc-item .toc-text {
  flex: 1;
  font-size: 13px;
  color: #333;
}

.mobile-toc-item.level-1 .toc-text {
  font-weight: 500;
  color: #1890ff;
}

.mobile-toc-item.level-2 {
  padding-left: 24px;
}

.mobile-toc-item.level-2 .toc-text {
  color: #555;
  font-size: 13px;
}

.mobile-toc-item.level-3 {
  padding-left: 36px;
}

.mobile-toc-item.level-3 .toc-text {
  color: #666;
  font-size: 13px;
}

.mobile-toc-item.level-4,
.mobile-toc-item.level-5,
.mobile-toc-item.level-6 {
  padding-left: 48px;
}

.mobile-toc-item.level-4 .toc-text,
.mobile-toc-item.level-5 .toc-text,
.mobile-toc-item.level-6 .toc-text {
  color: #999;
  font-size: 12px;
}

/* 简化章节导航样式 */
.content_st h1,
.content_st h2,
.content_st h3,
.content_st h4,
.content_st h5,
.content_st h6 {
  scroll-margin-top: 0px !important;
}

.section-nav {
  position: fixed;
  top: 50%;
  right: 70px;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9997;
  width: 200px;
  max-height: 400px;
  overflow-y: auto;
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.section-nav.show {
  display: block;
  opacity: 1;
}

/* 998px以上默认显示，通过JavaScript控制 */
@media (min-width: 998px) {
  .section-nav {
    display: block;
  }
}

.nav-wrapper {
  position: relative;
}

.nav-list {
  padding: 0;
  margin: 0;
}

.nav-item {
  padding: 3px 0;
  line-height: 1.5;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s ease;
  border-left: 2px solid transparent;
  padding-left: 8px;
  margin-left: -8px;
}

.nav-item:hover {
  color: #1890ff;
}

.nav-item-active {
  color: #1890ff !important;
  border-left-color: #1890ff;
  font-size: 12px;
}
/* 英文状态下的旋转样式 */
.rotate-text {
  display: inline-block;
  position: relative;
  transform: rotate(90deg);
  white-space: nowrap;
  transform-origin: center center;
}

/* 中文状态下的垂直排列样式 */
.rotate-text-zh {
  display: inline-block;
  position: relative;
  white-space: nowrap;
  writing-mode: vertical-rl;
  text-orientation: upright;
}

/* 响应式样式 */
@media (max-width: 1600px) {
  .section-nav {
    right: 50px; /* 配合gotopBtn的50px位置 */
  }
}

@media (max-width: 1440px) {
  .section-nav {
    right: 50px;
  }
}

@media (max-width: 1280px) {
  .section-nav {
    right: 50px;
    width: 140px;
  }
}

@media (max-width: 1024px) {
  .sectionNavBtn {
    display: none !important;
  }
  .section-nav {
    right: 10px; /* 配合gotopBtn的10px位置 */
    width: 130px;
  }
  .gotopBtn {
    right: 10px !important;
  }
}

@media (max-width: 1200px) {
  .section-nav {
    right: 10px;
    width: 120px;
  }
  .gotopBtn {
    right: 10px !important;
  }
}

/* 1700px及以下的新样式 */
@media screen and (max-width: 1700px) {
  .sectionNavBtn {
    display: none !important;
  }

  .mobile-section-nav-btn {
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 8px; /* 基础padding */
    cursor: pointer;
    z-index: 9998;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    width: 40px;
    height: auto;
    min-height: 120px; /* 增加高度以完整显示"Section Navigation" */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-items: center;
    gap: 6px;

    /* 优化容器渲染，防止点击时抖动 */
    -webkit-tap-highlight-color: transparent;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }

  /* 英文状态下的容器额外padding */
  .mobile-section-nav-btn .nav-text.english {
    margin: 8px 0; /* 通过margin补偿旋转后的视觉边距 */
  }

  .mobile-section-nav-btn:hover {
    background: #f5f5f5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    /* 确保hover状态不会导致文字抖动 */
    transform: translateY(-50%);
    backface-visibility: hidden;
  }

  .mobile-section-nav-btn:active {
    /* 优化点击状态，防止抖动 */
    transform: translateY(-50%) scale(0.98);
    transition: transform 0.1s ease;
    backface-visibility: hidden;
  }

  .nav-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    transition: transform 0.3s ease;
  }

  .nav-arrow-open {
    transform: rotate(180deg);
  }

  /* 中文状态下的垂直书写 */
  .nav-text {
    //writing-mode: vertical-rl;
    text-orientation: upright;
    font-size: 12px;
    color: #333;
    line-height: 1.2;
    letter-spacing: 1px;
    padding: 0 8px; /* 恢复中文文字的左右padding */
    //white-space: nowrap;
  }

  /* 英文状态下的旋转样式 */
  .nav-text.english {
    transform: rotate(90deg);
    transform-origin: center;
    font-size: 12px;
    color: #333;
    line-height: 1.2;
    letter-spacing: 0.5px;
    white-space: nowrap;
    height: 100px; /* 足够高度完整显示"Section Navigation" */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px; /* 设置固定宽度，移除max-width限制 */
    overflow: visible; /* 允许文字完整显示 */
    padding: 0; /* 移除文字自身padding，通过外部容器控制 */
    margin: 0; /* 确保没有额外margin */

    /* 优化旋转文字渲染，防止模糊抖动 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    backface-visibility: hidden;
    will-change: transform;
    transform-style: preserve-3d;
    perspective: 1000px;
  }

  .section-nav {
    position: fixed;
    top: 50%;
    right: 70px;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9997;
    width: 200px;
    max-height: 400px;
    overflow-y: auto;
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .section-nav.show {
    display: block;
    opacity: 1;
  }

  .nav-item {
    padding: 10px 15px;
    font-size: 14px;
    border-bottom: 1px solid #f5f5f5;
    transition: background-color 0.2s ease;
  }

  .nav-item:last-child {
    border-bottom: none;
  }

  .nav-item:hover {
    background: #f5f5f5;
  }

  .nav-item-active {
    background: #e6f7ff;
    color: #1890ff;
    border-left: 3px solid #1890ff;
    font-weight: 500;
  }
}

/* 高分辨率屏幕优化 */
@media (min-width: 1920px) {
  .section-nav {
    right: 100px; /* 给回到顶部按钮留足够空间 */
    width: 160px;
  }

  .nav-wrapper {
    padding: 0 24px;
  }

  :deep(.ant-anchor-link-title) {
    font-size: 15px;
  }
}

/* 确保回到顶部按钮始终可见 */
:deep(.gotopBtn) {
  z-index: 9999 !important;
}

/* 章节导航按钮样式调整 */
:deep(.sectionNavBtn) {
  z-index: 9997 !important;
}

.content_right {
  width: 100%;
}

.subscribe-content-box-div{
  width: 100%;
}
@media (max-width: 768px) {
  .git-input {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6,
.txt.ck-content h1,
.txt.ck-content h2,
.txt.ck-content h3,
.txt.ck-content h4,
.txt.ck-content h5,
.txt.ck-content h6 {
  font-weight: bold !important;
}

/* 1701px及以上，section-nav 始终显示，按钮隐藏 */
@media (min-width: 1701px) {
  .section-nav {
    display: block !important;
    opacity: 1 !important;
    right: 100px;
    z-index: 9998;
  }
  .mobile-section-nav-btn {
    display: none !important;
  }
}
/* 清理原有997/998/1444/1445/1440/1280等相关断点，统一为1700px */
// ... existing code ...
</style>
